import * as Yup from "yup";
import {
  Backdrop,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Divider,
  InputAdornment,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  Autocomplete,
  IconButton,
} from "@mui/material";
import Select from "react-select";
import { Field, FieldArray, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import {
  TerminalActions,
  getMerchant,
  getTerminalOptions,
  getModeList,
  Log,
  getActiveBusinessEntity,
  sendDataWithPost,
  sendDataWithGet,
} from "../../services/services";
import { getCurrencyListByHost } from "../../services/payment";
import MultiSelectField from "../../components/table/MultiSelectField";
import { AddCircleOutlined, Close, Visibility, VisibilityOff } from "@mui/icons-material";
import { SingleSelectType } from "../../components/table/Filter";
import {
  showGrabPayDynamicField,
  showWorldPayDynamicField,
  showNomuPayDynamicField,
  showRazerDynamicField,
  showTouchNGoDynamicField,
  showFiuuDynamicField,
  showFiuuFixedFeeDynamicField,
  showAllinpayDynamicField,
  showShopbackDynamicField,
  showNetsDynamicField,
  showHostFiuuDynamicField,
  showRevPayDynamicField,
  showCybersourceDynamicField,
  showDashDynamicField,
  showAliPayDynamicField,
  showAtomeDynamicField,
  showPaydeeDynamicField,
  showBSNDynamicField,
  showShopeePayMYDynamicField,
  showWeChatDynamicField,
  resetPaymentHostRateFields,
} from "../../utils/terminal_dynamic_util";
import { MPI_TYPE_LIST, SUB_MERCHANT_COUNTRY_CODE, LIQUID_PAYEE_PREFIX, PAYMENT_HOST_LIST, MIN_AMOUNT_DEFAULT } from "../../utils/constants";
import FormDialog from "../../components/FormDialog";
import { styles } from "../../utils/styles";
import { LoadingButton } from "@mui/lab";
import AllinpayFields from "../../components/Admin-Terminal/PaymentMethods/AllinpayFields";
import FiuuFixedFeeFields from "../../components/Admin-Terminal/PaymentMethods/FiuuFixedFeeFields";

const UnavailableOptionItem = <MenuItem disabled>Options unavailable</MenuItem>;
const transformEmptyToNull = (value, originalValue) => {
  if (originalValue === "" || originalValue === null || originalValue === undefined) {
    return null;
  }

  return Number.isNaN(value) ? null : value;
};

const CreateNewTerminal = ({ open, onClose }) => {
  const [businessEntityOptions, setBusinessEntityOptions] = useState();
  const [businessOptionLoaded, setBusinessOptionLoaded] = useState(false);
  const [merchantOptions, setMerchantOptions] = useState();
  const [merchantOptionLoaded, setMerchantOptionsLoaded] = useState(false);
  const [terminalOptions, setTerminalOptions] = useState();
  const [terminalOptionsLoaded, setTerminalOptionsLoaded] = useState(false);
  const [modeOptions, setModeOptions] = useState([]);
  const [selectedMode, setSelectedMode] = useState("");

  const [currencyByHost, setCurrencyByHost] = useState(null);
  const [paynowDescriptor, setPaynowDescriptor] = useState();
  const [mpiList, setMpiList] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState({});

  let paymentBrands = [];
  const [selectedPaymentBrands, setSelectedPaymentBrands] = useState([]);

  let paymentHosts = [];
  const [selectedPaymentHosts, setSelectedPaymentHosts] = useState([]);

  const [selectedBusiness, setSelectedBusiness] = useState();

  const [routeGw2, setRouteGw2] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isLoadingGenerateOperatorPassowrd, setLoadingGenerateOperatorPassword] = useState(false);

  const findPossibleBrands = (method) => {
    if (!terminalOptions) return UnavailableOptionItem;
    if (method !== "") {
      let brands = terminalOptions.find((e) => e.id === method);
      if (brands) {
        paymentBrands = paymentBrands.concat(
          brands.payment_brand_payment_method
        );
        brands = brands.payment_brand_payment_method;
      } else {
        return UnavailableOptionItem;
      }

      const brandList = brands.map((brand) => (
        <MenuItem key={brand.id} value={brand.id}>
          {brand.name}
        </MenuItem>
      ));
      return brandList.length > 0 ? brandList : UnavailableOptionItem;
    }

    return UnavailableOptionItem
  };

  const findPossibleHosts = (method, brand) => {
    if (method === "" && brand === "") return UnavailableOptionItem;
    let brands = terminalOptions.find(
      (e) => e.id === method
    ).payment_brand_payment_method;

    let hosts = brands.find((e) => e.id === brand);
    if (hosts) {
      paymentHosts = paymentHosts.concat(hosts.payment_host_payment_brand);

      return hosts.payment_host_payment_brand?.length > 0 ? (
        hosts.payment_host_payment_brand.map((host) => (
          <MenuItem key={host.id} value={host.id}>
            {host.name}
          </MenuItem>
        ))
      ) : UnavailableOptionItem;
    }

    return UnavailableOptionItem;
  };

  const handleGenerateOperatorPassword = (cb) => {
    setLoadingGenerateOperatorPassword(true);
    const url = "/merchant/pending_terminal/generate_operator_password/";
    sendDataWithPost(url, {}, cb, () => setLoadingGenerateOperatorPassword(false));
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    // To get payment host name to check for dynamic field
    let list = [];
    values.payment.forEach((p) => {
      list.push(p);
    });
    list.forEach((value, index) => {
      const default_bin_routing = value["default_bin_routing"];
      const min_card_range = value["min_card_range"];
      const max_card_range = value["max_card_range"];
      const isTouchNGo = selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.TOUCHNGO);
      const isShopeePayMY = selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.SHOPEEPAY_MY);

      const isGrabPayV1 = selectedPaymentHosts[index]
        ?.toLowerCase()
        .includes(PAYMENT_HOST_LIST.GRABPAY_V1);

      if (!selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.GRABPAY)) {
        delete value["grabpay_merchant_id"];
        delete value["grabpay_terminal_id"];
        delete value["payment_expiry_time"];
        delete value["postpaid"];
        delete value["installment_4"];
        delete value["min_amt_postpaid"];
        delete value["min_amt_installment_4"];
      }

      if (isGrabPayV1) {
        // GRABPAY_V1 only uses these 2 fields
        delete value["payment_expiry_time"];
        delete value["postpaid"];
        delete value["installment_4"];
        delete value["min_amt_postpaid"];
        delete value["min_amt_installment_4"];
      }
      if (!selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.WORLDPAY)) {
        delete value["pf_id"];
        delete value["sub_name"];
        delete value["sub_id"];
        delete value["sub_city"];
        delete value["sub_country_code"];
        delete value["sub_postal_code"];
        delete value["enable_vis"];
        // delete value["currency_list"];
        delete value["enabled_3ds"];
        delete value["default_bin_routing"];
        delete value["partner_merchant_reference_id"];
        delete value["mcc"];
        delete value["min_card_range"];
        delete value["max_card_range"];
      }

      if (!selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.NOMU)) {
        delete value["default_bin_routing"];
        delete value["min_card_range"];
        delete value["max_card_range"];
        delete value["processing_account_id"];
      }

      if (selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.NOMU)) {
        value["min_card_range"] = min_card_range;
        value["max_card_range"] = max_card_range;
        value["default_bin_routing"] = default_bin_routing;
      }

      if (!showRazerDynamicField(selectedPaymentHosts[index]) && !showFiuuDynamicField(selectedPaymentHosts[index])) {
        delete value["secret_key"];
        delete value["verification_key"];
        delete value["channel"];
      }

      if (!showRazerDynamicField(selectedPaymentHosts[index]) &&
          !showFiuuDynamicField(selectedPaymentHosts[index]) &&
          !showAllinpayDynamicField(selectedPaymentHosts[index])) {
        delete value["merchant_id"];
        delete value['terminal_id'];
      }

      if (!showShopbackDynamicField(selectedPaymentHosts[index])) {
        delete value["access_key_id"];
        delete value["access_key_secret"];
        delete value["pos_id"];
      }

      if (!showNetsDynamicField(selectedPaymentHosts[index])) {
        delete value["secret_id"];
        delete value["key_id"];
        delete value["mid"];
        delete value["tid"];
        delete value['institution_code'];
        delete value['condition_code'];
      }
      if (!showHostFiuuDynamicField(selectedPaymentHosts[index])) {
        delete value["host_fiuu_mid"];
        delete value["host_fiuu_verify_key"];
        delete value["host_fiuu_secret_key"];
        // delete value["host_fiuu_email"];
        // delete value['host_fiuu_password'];
      }
      if (!showFiuuFixedFeeDynamicField(selectedPaymentHosts[index])) {
        delete value["base_fix_fee_local"];
        delete value["markup_fix_fee_local"];
        delete value["base_fix_fee_foreign"];
        delete value["markup_fix_fee_foreign"];
      }

      if (!showCybersourceDynamicField(selectedPaymentHosts[index])) {
        delete value["cybs_merchant_id"];
        delete value["cybs_merchant_keyid"];
        delete value["cybs_merchant_secretkey"];
        delete value["cybs_mpi_type"];
        delete value["ipp_enabled"];
        delete value["ipp_plans"];
      } else {
        // If IPP is disabled, clear the plans
        if (!value["ipp_enabled"]) {
          delete value["ipp_plans"];
        }
      }

      if (!showRevPayDynamicField(selectedPaymentHosts[index])) {
        delete value["revpay_merchant_id"];
      }

      if (!selectedPaymentHosts[index]?.toLowerCase().includes("paydee") &&
        !selectedPaymentHosts[index]?.toLowerCase().includes("bsn")) {
        delete value["local_debit_markup_rate"];
        delete value["local_debit_base_rate"];
        delete value["local_credit_markup_rate"];
        delete value["local_credit_base_rate"];
        delete value["foreign_markup_rate"];
        delete value["foreign_base_rate"];
        delete value["whichever_higher_mdr_cents"];
        delete value["micro_transaction_amount"];
        delete value["mdr_less_than_micro_transaction_amount_cents"];
        delete value["bank_mid"];
        delete value["bank_tid"];
      }

      if (!selectedPaymentHosts[index]?.toLowerCase().includes("bsn")) {
        delete value["my_debit_markup_rate"];
        delete value["my_debit_base_rate"];
      }

      if (!selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.SHOPEEPAY_MY)) {
        delete value["convenience_fee_indicator"];
        delete value["convenience_fee_fixed"];
        delete value["convenience_fee_percentage"];
        delete value["my_merchant_ext_id"];
        delete value["my_store_ext_id"];
      }

      if (!selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.TOUCHNGO)) {
        delete value["touchngo_expiry_time"];
        delete value["touchngo_merchant_id"];
        delete value["touchngo_client_id"];
        delete value["touchngo_client_secret"];
      }

      if (!isTouchNGo && !isShopeePayMY) {
        delete value["is_autodebit_enabled"];
        delete value["autodebit_amount"];
      }

      if (!showDashDynamicField(selectedPaymentHosts[index])) {
        delete value["counter_id"];
        delete value["counter_msisdn"];
        delete value["counter_pin"];
      }
      if (!showAliPayDynamicField(selectedPaymentHosts[index])) {
        delete value["store_id"];
      }

      if (!showAtomeDynamicField(selectedPaymentHosts[index])) {
        delete value["atome_username"];
        delete value["atome_password"];
        delete value["username"];
        delete value["password"];
      } else {
        value["username"] = value["atome_username"] ?? "";
        value["password"] = value["atome_password"] ?? "";
        delete value["atome_username"];
        delete value["atome_password"];
      }
      if (!showWeChatDynamicField(selectedPaymentHosts[index])) {
        delete value["partner_id"];
      }
      if (!showAllinpayDynamicField(selectedPaymentHosts[index])) {
        delete value["allinpay_partner_id"];
        delete value["allinpay_base_rate_local"];
        delete value["allinpay_markup_rate_local"];
        delete value["allinpay_base_rate_foreign"];
        delete value["allinpay_markup_rate_foreign"];
      } else {
        delete value["base_rate"];
        delete value["markup_rate"];
      }
      if (!value.is_shopeepay_brand) {
        delete value["credit_base_rate"];
        delete value["credit_markup_rate"];
        delete value["spaylater_base_rate"];
        delete value["spaylater_markup_rate"];
        delete value["merchant_ext_id"];
        delete value["store_ext_id"];
      } else {
        // For ShopeePay: wallet rates use base_rate/markup_rate directly
        // credit and spaylater rates go to ShopeePayHostDynamicInfoPending
        if (!value.shopeepay_credit_enabled) {
          delete value["credit_base_rate"];
          delete value["credit_markup_rate"];
        }

        if (!value.shopeepay_spaylater_enabled) {
          delete value["spaylater_base_rate"];
          delete value["spaylater_markup_rate"];
        }

        // Wallet is always enabled for ShopeePay, so base_rate and markup_rate are always required
      }

      delete value["is_shopeepay_brand"];
      delete value["shopeepay_credit_enabled"];
      delete value["shopeepay_spaylater_enabled"];
      delete value["shopeepay_wallet_enabled"];

    });

    let map = {
      businessEntity: values.businessEntity?.id,
      merchant: values.merchant,
      mode: values.mode,
      operator_id: values.operator_id,
      operator_password: values.operator_password,
      payment: list,
    };

    Log.info('Click button [Submit] - Create A New Terminal', map)
    try {
      await TerminalActions("ADD", map, onClose);
    } catch (error) {

    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    getActiveBusinessEntity((res) => {
      if (res?.business_entity) setBusinessEntityOptions(res.business_entity)
    }, setBusinessOptionLoaded);
    getTerminalOptions(setTerminalOptions, setTerminalOptionsLoaded);
    getModeList(setModeOptions);
  }, []);

  useEffect(() => {
    const url = "/merchant/paynow_descriptor_v2/filter/";
    sendDataWithPost(url, {
      no_pagination: true,
      status: 'PASS'
    }, data => {
      const list = Array.isArray(data) ? data : (data?.results ?? []);
      const groupedData = list.reduce((acc, item) => {
        const hostName = item.payment_host.name.toLowerCase();
        // const status = item.status.toLowerCase();

        if ([PAYMENT_HOST_LIST.DBS, PAYMENT_HOST_LIST.SCB].includes(hostName?.toLowerCase())) {
          acc[hostName] = acc[hostName] || [];
          acc[hostName].push({
            id: item.id,
            name: item.is_custom ? item.party_name : item.merchant_name,
            paynow_proxy_suffix: item.paynow_proxy_suffix
          });
        }
        return acc;
      }, {});

      setPaynowDescriptor(groupedData);
    });
  }, [])

  useEffect(() => {
    const url = "/mpi_details/list/";
    sendDataWithGet(url, setMpiList);
  }, [])

  useEffect(() => {
    if (selectedBusiness) {
      getMerchant((res) => {
        const list = Array.isArray(res) ? res : (res?.results ?? []);
        setMerchantOptions(list);
      }, setMerchantOptionsLoaded, {
        name: "",
        mid: "",
        business_entity: selectedBusiness,
        is_active: true,
        no_pagination: true
      });
    } else {
      setMerchantOptions([])
    }
  }, [selectedBusiness]);

  const initialRow = [
    {
      payment_method: "",
      payment_brand: "",
      payment_host: "",
      base_rate: "",
      markup_rate: "",
      base_rate_foreign: "",
      markup_rate_foreign: "",
      base_fix_fee_local: "0",
      markup_fix_fee_local: "0",
      base_fix_fee_foreign: "0",
      markup_fix_fee_foreign: "0",
      base_rate_installment: "",
      markup_rate_installment: "",
      credit_base_rate: "",
      credit_markup_rate: "",
      spaylater_base_rate: "",
      spaylater_markup_rate: "",
      shopeepay_credit_enabled: false,
      shopeepay_spaylater_enabled: false,
      shopeepay_wallet_enabled: false,
      merchant_ext_id: "",
      store_ext_id: "",
      is_shopeepay_brand: false,
      grab_dynamic_info_id: "",
      grabpay_merchant_id: "",
      grabpay_terminal_id: "",
      payment_expiry_time: "",
      postpaid: false,
      installment_4: false,
      min_amt_postpaid: "",
      min_amt_installment_4: "",
      pf_id: "",
      sub_name: "",
      sub_id: "",
      sub_street: "",
      sub_city: "",
      sub_country_code: "",
      sub_postal_code: "",
      mcc: "",
      partner_merchant_reference_id: "",
      enable_vis: false,
      currency_list: [],
      enabled_3ds: false,
      default_bin_routing: true,
      min_card_range: "",
      max_card_range: "",
      processing_account_id: "",
      secret_key: "",
      verification_key: "",
      merchant_id: "",
      channel: "",
      acquiring_institution_id: "",
      forwarding_institution_id: "",
      acceptor_id: "",
      processing_code: "",
      touchngo_expiry_time: "",
      touchngo_merchant_id: "",
      touchngo_client_id: "",
      touchngo_client_secret: "",
      is_autodebit_enabled: "",
      autodebit_amount: "",
      route_enabled: false,
      host_fiuu_mid: "",
      // host_fiuu_password:"",
      // host_fiuu_email:"",
      host_fiuu_secret_key: "",
      host_fiuu_verify_key: "",
      cybs_merchant_id: "",
      cybs_merchant_secretkey: "",
      cybs_merchant_keyid: "",
      cybs_mpi_type: 0,
      ipp_enabled: false,
      ipp_plans: [],
      gw2_params: {
        mcptid: "",
        etype: ""
      },
      paynow_descriptor_id: "",
      ref_2: "",
      payee: "",
      line_pay_merchant_id: "",
      sub_mid: "",
      my_merchant_ext_id: "",
      my_store_ext_id: "",
      convenience_fee_indicator: "",
      convenience_fee_fixed: "",
      convenience_fee_percentage: "",
      store_id: "",
      atome_username: "",
      atome_password: "",
      mpi_type: 0,
      mpi_id: "",
      partner_id: "",
      allinpay_partner_id: "",
      allinpay_base_rate_local: "",
      allinpay_markup_rate_local: "",
      allinpay_base_rate_foreign: "",
      allinpay_markup_rate_foreign: "",
    },
  ];

  const clearedPaymentRow = () =>
    Object.entries(initialRow[0]).reduce((acc, [key, value]) => {
      if (typeof value === "string") acc[key] = "";
      else if (Array.isArray(value)) acc[key] = [];
      else if (value && typeof value === "object") acc[key] = { ...value };
      else acc[key] = value;
      return acc;
    }, {});

  const resetPaymentRowOnHostChange = (row, hostId) => ({
    ...row,
    ...clearedPaymentRow(),
    payment_method: row.payment_method,
    payment_brand: row.payment_brand,
    payment_host: hostId,
    currency_list: row.currency_list ?? [],
    is_shopeepay_brand: row.is_shopeepay_brand,
    shopeepay_wallet_enabled: row.is_shopeepay_brand,
  });

  return (
    <Container>
      {businessOptionLoaded ? (
        <Box>
          <Formik
            initialValues={{
              mode: "",
              businessEntity: "",
              merchant: "",
              operator_id: "",
              operator_password: "",
              payment: initialRow,
            }}
            onSubmit={handleSubmit}
            validateOnChange={true}
            validateOnBlur={true}
            validationSchema={Yup.object({
              mode: Yup.string().required("Mode is required"),
              businessEntity: Yup.object().required(
                "Business entity is required"
              ),
              merchant: Yup.string().required("Merchant is required"),
              operator_password: Yup.string().when("mode", {
                is: (val) => {
                  return val && modeOptions?.some((mode) => mode.id.toString() === val.toString() && mode.mode.toLowerCase() === "ffastpay")
                },
                then: (schema) =>
                  schema
                    .min(6, 'Password should be of minimum 6 characters length')
                    .required("Operator Password is required"),
                otherwise: (schema) => schema.notRequired(),
              }),

              payment: Yup.array().of(
                Yup.object().shape({
                  payment_method: Yup.string().required(
                    "Payment method must be selected"
                  ),
                  payment_brand: Yup.string().required(
                    "Payment brand must be selected"
                  ),
                  payment_host: Yup.string().required(
                    "Payment host must be selected"
                  ),
                  base_rate: Yup.number()
                    .nullable()
                    .transform(transformEmptyToNull)
                    .test("base-rate-required", "This field is required", function (value) {
                      const index = Number(this.path.match(/payment\[(\d+)\]/)?.[1]);
                      return showAllinpayDynamicField(selectedPaymentHosts[index]) || value != null;
                    }),
                  markup_rate: Yup.number()
                    .transform(transformEmptyToNull)
                    .nullable()
                    .test("markup-rate-required", "This field is required", function (value) {
                      const index = Number(this.path.match(/payment\[(\d+)\]/)?.[1]);
                      return showAllinpayDynamicField(selectedPaymentHosts[index]) || value != null;
                    }),
                  credit_base_rate: Yup.number()
                    .transform(transformEmptyToNull)
                    .when("shopeepay_credit_enabled",
                      {
                        is: (creditEnabled) => creditEnabled,
                        then: (schema) => schema.required("This field is required"),
                        otherwise: (schema) => schema.notRequired().nullable(),
                      }
                    ),
                  credit_markup_rate: Yup.number()
                    .transform(transformEmptyToNull)
                    .when("shopeepay_credit_enabled",
                      {
                        is: (creditEnabled) => creditEnabled,
                        then: (schema) => schema.required("This field is required"),
                        otherwise: (schema) => schema.notRequired().nullable(),
                      }
                    ),
                  spaylater_base_rate: Yup.number()
                    .transform(transformEmptyToNull)
                    .when("shopeepay_spaylater_enabled",
                      {
                        is: (spaylaterEnabled) => spaylaterEnabled,
                        then: (schema) => schema.required("This field is required"),
                        otherwise: (schema) => schema.notRequired().nullable(),
                      }
                    ),
                  spaylater_markup_rate: Yup.number()
                    .transform(transformEmptyToNull)
                    .when("shopeepay_spaylater_enabled",
                      {
                        is: (spaylaterEnabled) => spaylaterEnabled,
                        then: (schema) => schema.required("This field is required"),
                        otherwise: (schema) => schema.notRequired().nullable(),
                      }
                    ),
                  shopeepay_credit_enabled: Yup.boolean(),
                  shopeepay_spaylater_enabled: Yup.boolean(),
                  shopeepay_wallet_enabled: Yup.boolean(),
                  merchant_ext_id: Yup.string(),
                  store_ext_id: Yup.string(),
                  is_shopeepay_brand: Yup.boolean(),
                  base_rate_installment: Yup.number()
                    .transform(transformEmptyToNull)
                    .nullable(),
                  markup_rate_installment: Yup.number()
                    .transform(transformEmptyToNull)
                    .nullable(),
                  currency_list: Yup.array()
                    .of(
                      Yup.object().shape({
                        id: Yup.string().required(),
                        min_amount: Yup.number()
                          .transform((value) => (isNaN(value) ? undefined : value))
                          .required('Min amount is required')
                          .min(0, "Min amount must be at least 0"),
                      })
                    )
                    .min(1, 'At least one currency must be selected').required(),
                  payee: Yup.string().when('payment_host', {
                    is: 'liquidnet',
                    then: Yup.string()
                      .required('Payee is required for liquidnet')
                      .length(15, 'Payee must be exactly 15 characters (4000571 + 8 characters)')
                      .matches(/^4000571.{8}$/, 'Payee must start with 4000571 and have exactly 8 additional characters'),
                    otherwise: Yup.string()
                  }),
                  line_pay_merchant_id: Yup.string().when('payment_host', {
                    is: 'linepay',
                    then: Yup.string()
                      .required('LINE Pay Merchant ID is required for PromptPay')
                      .max(100, 'LINE Pay Merchant ID must be at most 100 characters'),
                    otherwise: Yup.string()
                  }),
                  sub_mid: Yup.string().when('payment_host', {
                    is: 'fomopay',
                    then: Yup.string()
                      .max(128, 'Sub MID must be at most 128 characters'),
                    otherwise: Yup.string()
                  }),
                  atome_username: Yup.string().when('payment_host', {
                    is: 'atome',
                    then: (schema) =>
                      schema
                        .required('Username is required for Atome')
                        .max(50, 'Username must be at most 50 characters'),
                    otherwise: (schema) => schema.notRequired(),
                  }),
                  atome_password: Yup.string().when('payment_host', {
                    is: 'atome',
                    then: (schema) =>
                      schema
                        .required('Password is required for Atome')
                        .max(255, 'Password must be at most 255 characters'),
                    otherwise: (schema) => schema.notRequired(),
                  }),
                })
              ),
            })}
          >
            {({
              values,
              touched,
              errors,
              isSubmitting,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              console.log({ errors })
              const resetShopeePayFields = (routeIndex, isShopeePay = false) => {
                setFieldValue(`payment.${routeIndex}.shopeepay_credit_enabled`, false);
                setFieldValue(`payment.${routeIndex}.shopeepay_spaylater_enabled`, false);
                // Wallet is always enabled for ShopeePay
                setFieldValue(`payment.${routeIndex}.shopeepay_wallet_enabled`, isShopeePay);

                if (!isShopeePay) {
                  setFieldValue(`payment.${routeIndex}.base_rate`, "");
                  setFieldValue(`payment.${routeIndex}.markup_rate`, "");
                }

                setFieldValue(`payment.${routeIndex}.credit_base_rate`, "");
                setFieldValue(`payment.${routeIndex}.credit_markup_rate`, "");
                setFieldValue(`payment.${routeIndex}.spaylater_base_rate`, "");
                setFieldValue(`payment.${routeIndex}.spaylater_markup_rate`, "");
              };

              return (
                <FormDialog
                  open={open}
                  onClose={onClose}
                  title="Create A New Terminal"
                  scroll="paper"
                  handleSubmit={handleSubmit}
                  loading={isSubmitting}
                  sx={{ p: 0 }}
                >
                  <Form autoComplete="off" noValidate>
                    <Grid
                      container
                      rowSpacing={2}
                      columnSpacing={3}
                      sx={{ alignItems: "center", py: 2 }}
                    >
                      <Grid
                        container
                        rowSpacing={1}
                        columnSpacing={1}
                        sx={{ alignItems: "center", position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1, px: 3, ml: 3 }}
                      >
                        <Grid item md={1} xs={1}>
                          <Typography
                            variant="subtitle1"
                            sx={{ textAlign: "right" }}
                          >
                            Mode*
                          </Typography>
                        </Grid>

                        <Grid item md={2} xs={2}>
                          {/* <SingleSelectType
                        id="true"
                        options={modeOptions.map((mode) => ({
                          id: mode.id,
                          name: mode.mode,
                        }))}
                        label="Mode"
                        name="mode"
                        selected={values.mode}
                        // setSelected={setSelectedMode}
                        onChange={handleChange}
                        size="small"
                        error={Boolean(touched.mode && errors.mode)}
                        helperText={touched.mode && errors.mode}
                      /> */}
                          <TextField
                            label="Mode"
                            margin="normal"
                            select
                            id="mode"
                            name="mode"
                            size="small"
                            color="secondary"
                            value={values.mode}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            fullWidth
                            onBlur={handleBlur}
                            error={Boolean(touched.mode && errors.mode)}
                            helperText={touched.mode && errors.mode}
                            disabled={isSubmitting}
                          >
                            {modeOptions?.length > 0
                              ? modeOptions.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.mode}
                                </MenuItem>
                              ))
                              : UnavailableOptionItem}
                          </TextField>
                        </Grid>

                        <Grid item md={2} xs={2}>
                          <Typography
                            variant="subtitle1"
                            sx={{ textAlign: "right" }}
                          >
                            Business Entity*
                          </Typography>
                        </Grid>

                        <Grid item md={3} xs={3}>
                          <Autocomplete
                            options={businessEntityOptions?.map((entity) => ({
                              id: entity.id,
                              label: entity.business_name,
                            })) || []}
                            value={values.businessEntity || null}
                            isOptionEqualToValue={(option, value) => {
                              if (!option || !value) return false;
                              return option.id === value.id;
                            }}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id} value={option.id}>
                                {option.label}
                              </li>
                            )}
                            onChange={(e, newValue) => {
                              setFieldValue("businessEntity", newValue ?? "");
                              setSelectedBusiness(newValue?.id);
                            }}
                            fullWidth
                            disabled={isSubmitting}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Business Entity"
                                error={Boolean(
                                  touched.businessEntity &&
                                  errors.businessEntity
                                )}
                                size="small"
                                name="businessEntity"
                                helperText={
                                  touched.businessEntity && errors.businessEntity
                                }
                              />
                            )}
                          />
                        </Grid>

                        <Grid item md={2} xs={2}>
                          <Typography
                            variant="subtitle1"
                            sx={{ textAlign: "right" }}
                          >
                            Merchant*
                          </Typography>
                        </Grid>

                        <Grid item md={2} xs={2}>
                          <TextField
                            label="Merchant"
                            margin="normal"
                            select
                            id="merchant"
                            name="merchant"
                            size="small"
                            color="secondary"
                            value={values.merchant}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            error={Boolean(touched.merchant && errors.merchant)}
                            helperText={touched.merchant && errors.merchant}
                            sx={{ width: "100%" }}
                            disabled={isSubmitting}
                          >
                            {merchantOptions?.length > 0
                              ? merchantOptions.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              ))
                              : UnavailableOptionItem}
                          </TextField>
                        </Grid>

                        {values.mode && modeOptions?.some((mode) => mode.id === values.mode && mode.mode.toLowerCase() === "ffastpay") && (
                          <>
                            <Grid item md={1} xs={1}>
                              <Typography
                                variant="subtitle1"
                                sx={{ textAlign: "right" }}
                              >
                                Operator ID
                              </Typography>
                            </Grid>

                            <Grid item md={2} xs={2}>
                              <TextField
                                size="small"
                                label="Operator ID"
                                id={"operator_id"}
                                name={"operator_id"}
                                value={values.operator_id}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                                disabled={isSubmitting}
                              />
                            </Grid>

                            <Grid item md={2} xs={2}>
                              <Typography
                                variant="subtitle1"
                                sx={{ textAlign: "right" }}
                              >
                                Operator Password*
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={3}>
                              <TextField
                                type={showPassword ? 'text' : 'password'}
                                size="small"
                                fullWidth
                                label="Operator Password"
                                name="operator_password"
                                value={values.operator_password}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                                disabled={isSubmitting || isLoadingGenerateOperatorPassowrd}
                                error={Boolean(touched.operator_password && errors.operator_password)}
                                helperText={touched.operator_password && errors.operator_password}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton onClick={() => setShowPassword(!showPassword)}>
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                      </IconButton>
                                    </InputAdornment>
                                  )
                                }}
                              />
                            </Grid>

                            <Grid item>
                              <LoadingButton
                                variant="outlined"
                                color="error"
                                loading={isLoadingGenerateOperatorPassowrd}
                                onClick={() => handleGenerateOperatorPassword(data => setFieldValue("operator_password", data.operator_password))}
                              >
                                Regenerate
                              </LoadingButton>
                            </Grid>
                          </>
                        )}
                      </Grid>

                      <Grid item md={12} xs={12} sx={{ mx: 3, mb: 2 }}>
                        <Divider />
                      </Grid>

                      <Grid item md={12} xs={12} sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
                        <FieldArray name="payment">
                          {({ insert, remove, push }) => (
                            <Box>
                              {values.payment.length > 0 &&
                                values.payment.map((row, index) => {
                                  const isShopeePayBrand =
                                    values.payment[index]?.is_shopeepay_brand;
                                  const shopeeCreditEnabled =
                                    values.payment[index]?.shopeepay_credit_enabled;
                                  const shopeeSpaylaterEnabled =
                                    values.payment[index]?.shopeepay_spaylater_enabled;

                                  const handleShopeeToggle = (
                                    fieldName,
                                    dependentFields = []
                                  ) => {
                                    const fieldPath = `payment.${index}.${fieldName}`;
                                    const currentValue =
                                      values.payment[index]?.[fieldName];
                                    const nextValue = !currentValue;
                                    setFieldValue(fieldPath, nextValue);

                                    if (!nextValue) {
                                      dependentFields.forEach((dependentField) =>
                                        setFieldValue(dependentField, "")
                                      );
                                    }
                                  };

                                  return (
                                    <Card sx={{ p: 2, m: 2, mt: 0, mx: 3 }} key={index}>
                                      <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        sx={{ mb: 3 }}
                                      >
                                        <Typography variant="subtitle1">
                                          Route Mapping
                                        </Typography>
                                        <Button
                                          variant="outlined"
                                          color="error"
                                          onClick={() => {
                                            remove(index);
                                            if (paymentMethod[index]) {
                                              const newObj = { ...paymentMethod };
                                              delete newObj[index];
                                              setPaymentMethod(newObj);
                                            }
                                          }}
                                          startIcon={<Close />}
                                        >
                                          Delete
                                        </Button>
                                      </Stack>
                                      <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        sx={{ mb: 3 }}
                                        spacing={2}
                                      >
                                        <TextField
                                          required
                                          id={`payment.${index}.payment_method`}
                                          name={`payment.${index}.payment_method`}
                                          select
                                          label="Payment Method"
                                          value={values.payment[index].payment_method}
                                          onChange={(e, child) => {
                                            handleChange(e);
                                            let tempB = [...selectedPaymentBrands];
                                            tempB[index] = "";
                                            setSelectedPaymentBrands(tempB);

                                            let temp = [...selectedPaymentHosts];
                                            temp[index] = "";
                                            setSelectedPaymentHosts(temp);
                                            setPaymentMethod({ ...paymentMethod, [index]: child.props["dataPaymentMethod"] });

                                            setFieldValue(
                                              `payment.${index}.payment_host`,
                                              ""
                                            );
                                            setFieldValue(
                                              `payment.${index}.payment_brand`,
                                              ""
                                            );
                                            setFieldValue(
                                              `payment.${index}.is_shopeepay_brand`,
                                              false
                                            );
                                            resetShopeePayFields(index, false);
                                          }}
                                          sx={{ width: "100%" }}
                                          error={Boolean(
                                            touched.payment &&
                                            touched?.payment[index]
                                              ?.payment_method &&
                                            errors.payment &&
                                            errors?.payment[index]?.payment_method
                                          )}
                                          helperText={
                                            touched.payment &&
                                            touched?.payment[index]?.payment_method &&
                                            errors.payment &&
                                            errors?.payment[index]?.payment_method
                                          }
                                        >
                                          {terminalOptionsLoaded
                                            ? terminalOptions.map((method) => (
                                              <MenuItem
                                                key={method.id}
                                                value={method.id}
                                                dataPaymentMethod={method.name}
                                              >
                                                {method.name}
                                              </MenuItem>
                                            ))
                                            : []}
                                        </TextField>
                                        <TextField
                                          required
                                          id={`payment.${index}.payment_brand`}
                                          name={`payment.${index}.payment_brand`}
                                          select
                                          label="Payment Brand"
                                          value={values.payment[index].payment_brand}
                                          onChange={(e) => {
                                            handleChange(e);
                                            const brand = paymentBrands.find((h) => {
                                              return h.id === e.target.value;
                                            });
                                            const brandName = brand?.name?.toLocaleLowerCase() || "";
                                            if (brand) {
                                              let tempB = [...selectedPaymentBrands];
                                              tempB[index] = brandName;
                                              setSelectedPaymentBrands(tempB);
                                            }

                                            const isShopeeBrand = brandName === PAYMENT_HOST_LIST.SHOPEEPAY;
                                            setFieldValue(`payment.${index}.is_shopeepay_brand`, isShopeeBrand);
                                            resetShopeePayFields(index, isShopeeBrand);

                                            let temp = [...selectedPaymentHosts];
                                            temp[index] = "";
                                            setSelectedPaymentHosts(temp);
                                            setFieldValue(
                                              `payment.${index}.payment_host`,
                                              ""
                                            );
                                          }}
                                          sx={{ width: "100%" }}
                                          error={Boolean(
                                            touched.payment &&
                                            touched?.payment[index]
                                              ?.payment_brand &&
                                            errors.payment &&
                                            errors?.payment[index]?.payment_brand
                                          )}
                                          helperText={
                                            touched.payment &&
                                            touched?.payment[index]?.payment_brand &&
                                            errors.payment &&
                                            errors?.payment[index]?.payment_brand
                                          }
                                        >
                                          {findPossibleBrands(
                                            values.payment[index].payment_method
                                          )}
                                        </TextField>
                                        <TextField
                                          required
                                          id={`payment.${index}.payment_host`}
                                          name={`payment.${index}.payment_host`}
                                          select
                                          label="Payment Host"
                                          value={values.payment[index].payment_host}
                                          onChange={(e) => {
                                            handleChange(e);
                                            const host = paymentHosts.find((h) => {
                                              return h.id === e.target.value;
                                            });
                                            if (host) {
                                              if (selectedPaymentHosts[index]?.toLowerCase() !== host.name.toLowerCase()) {
                                                resetPaymentHostRateFields(
                                                  setFieldValue,
                                                  index,
                                                  host.name
                                                );
                                              }
                                              let temp = [...selectedPaymentHosts];
                                              temp[index] =
                                                host.name.toLocaleLowerCase();

                                              if (host.is_route_gw2) {
                                                let routeGw2Obj = { ...routeGw2 };
                                                routeGw2Obj[index] = {
                                                  name: host.name.toLocaleLowerCase(),
                                                  isRouteGw2: host.is_route_gw2
                                                };
                                                setRouteGw2(routeGw2Obj);
                                              }

                                              setSelectedPaymentHosts(temp);

                                              setFieldValue(
                                                `payment.${index}`,
                                                resetPaymentRowOnHostChange(values.payment[index], host.id)
                                              );
                                              getCurrencyListByHost(
                                                {
                                                  payment_host_ids: [host.id],
                                                },
                                                (res) => {
                                                  const [{ ...rest }] = res;
                                                  const supportedCurrencies = Array.isArray(rest.currencies) ? rest.currencies : [];
                                                  setFieldValue(
                                                    `payment.${index}.currency_list`,
                                                    (values.payment[index]?.currency_list ?? []).filter((c) =>
                                                      supportedCurrencies.some((sc) => sc.id === c.id)
                                                    )
                                                  );
                                                  if (!currencyByHost)
                                                    return setCurrencyByHost({
                                                      [host.id]: rest,
                                                    });

                                                  if (!currencyByHost[host.id]) {
                                                    setCurrencyByHost({ ...currencyByHost, [host.id]: rest });
                                                  }
                                                }
                                              );
                                            }
                                          }}
                                          sx={{ width: "100%" }}
                                          error={Boolean(
                                            touched.payment &&
                                            touched?.payment[index]?.payment_host &&
                                            errors.payment &&
                                            errors?.payment[index]?.payment_host
                                          )}
                                          helperText={
                                            touched.payment &&
                                            touched?.payment[index]?.payment_host &&
                                            errors.payment &&
                                            errors?.payment[index]?.payment_host
                                          }
                                        >
                                          {findPossibleHosts(
                                            values.payment[index].payment_method,
                                            values.payment[index].payment_brand
                                          )}
                                        </TextField>
                                      </Stack>
                                      <Divider sx={{ mb: 2 }} />
                                      {values.payment[index].payment_host && currencyByHost &&
                                        <Grid container column={6} alignItems="flex-start" sx={{ mb: 2 }}>
                                          <Grid item xs={4}>
                                            <Box sx={{ m: 1 }}>
                                              {(() => {
                                                const { payment_host, currency_list } = values.payment[index];
                                                const currencies = Array.isArray(currencyByHost[payment_host]?.currencies) ? currencyByHost[payment_host]?.currencies : [];
                                                const selectedValues = currencies.filter(({ id }) => currency_list?.some(c => c.id === id));

                                                const hasError = touched?.payment?.[index]?.currency_list && errors?.payment?.[index]?.currency_list;

                                                return (
                                                  <>
                                                    <Typography
                                                      sx={{
                                                        pb: 0.5,
                                                        color: hasError ? "#FF4842" : "#637381",
                                                        fontSize: 12,
                                                      }}
                                                    >
                                                      Currency *
                                                    </Typography>
                                                    <Select
                                                      id={`payment.${index}.currency_list`}
                                                      name={`payment.${index}.currency_list`}
                                                      getOptionLabel={(option) => option.currency}
                                                      getOptionValue={(option) => option.id}
                                                      closeMenuOnSelect={false}
                                                      isMulti
                                                      options={currencies}
                                                      value={selectedValues}
                                                      onChange={(event) =>
                                                        setFieldValue(
                                                          `payment.${index}.currency_list`,
                                                          event.map(({ id, currency }) => {
                                                            const existing = currency_list?.find(c => c.id === id);
                                                            return existing ? existing : { id, min_amount: MIN_AMOUNT_DEFAULT[currency] };
                                                          })
                                                        )
                                                      }
                                                      styles={{
                                                        control: (provided, state) => ({
                                                          ...provided,
                                                          minHeight: "30px",
                                                          height: "auto",
                                                          maxHeight: "100px",
                                                          overflow: "auto",
                                                        }),
                                                        valueContainer: (provided) => ({
                                                          ...provided,
                                                          maxHeight: "90px",
                                                          overflow: "auto",
                                                          flexWrap: "wrap",
                                                        }),
                                                        multiValue: (provided) => ({
                                                          ...provided,
                                                          maxWidth: "100%",
                                                        }),
                                                        multiValueLabel: (provided) => ({
                                                          ...provided,
                                                          overflow: "hidden",
                                                          textOverflow: "ellipsis",
                                                          whiteSpace: "nowrap",
                                                          maxWidth: "120px",
                                                        }),
                                                        indicatorsContainer: (provided) => ({
                                                          ...provided,
                                                          height: "30px",
                                                        }),
                                                        menuPortal: (base) => ({
                                                          ...base,
                                                          zIndex: 9999,
                                                        }),
                                                      }}
                                                      menuPortalTarget={document.body}
                                                    />
                                                    {hasError && typeof errors.payment[index].currency_list === 'string' && (
                                                      <Typography color="error" fontSize={12}>
                                                        {errors.payment[index].currency_list}
                                                      </Typography>
                                                    )}

                                                    {/* Render Min Amount Input for Each Selected Currency */}
                                                    {currency_list?.length > 0 && (
                                                      <Box sx={{ mt: 2 }}>
                                                        {/* <Typography variant="subtitle2" sx={{ mb: 1 }}>Min Amount</Typography> */}
                                                        {currency_list.map((currencyItem, cIndex) => {
                                                          const currencyInfo = currencies.find(c => c.id === currencyItem.id);
                                                          const currencyName = currencyInfo ? currencyInfo.currency : `Currency ID: ${currencyItem.id}`;
                                                          const fieldName = `payment.${index}.currency_list[${cIndex}].min_amount`;
                                                          const fieldError = errors?.payment?.[index]?.currency_list?.[cIndex]?.min_amount;
                                                          const fieldTouched = touched?.payment?.[index]?.currency_list?.[cIndex]?.min_amount;
                                                          const minAmtError = Boolean(fieldTouched && fieldError);

                                                          return (
                                                            <TextField
                                                              key={cIndex}
                                                              required
                                                              sx={{ m: 1 }}
                                                              InputLabelProps={{
                                                                shrink: true,
                                                              }}
                                                              InputProps={{
                                                                min: 0,
                                                                step: "any",
                                                                startAdornment: (
                                                                  <InputAdornment position="start">
                                                                    {currencyName}
                                                                  </InputAdornment>
                                                                ),
                                                              }}
                                                              onChange={(event) => {
                                                                const value = event.target.value;

                                                                // Allow empty value so user can clear the input
                                                                if (value === "") {
                                                                  handleChange(event);
                                                                  return;
                                                                }

                                                                // Prevent negative number
                                                                if (Number(value) < 0) {
                                                                  return;
                                                                }

                                                                handleChange(event);
                                                              }}
                                                              onKeyDown={(event) => {
                                                                // Prevent negative, positive sign, and exponential input
                                                                if (["-", "+", "e", "E"].includes(event.key)) {
                                                                  event.preventDefault();
                                                                }
                                                              }}
                                                              label={`Min Amount`}
                                                              id={fieldName}
                                                              name={fieldName}
                                                              value={currencyItem.min_amount ?? MIN_AMOUNT_DEFAULT[currencyInfo?.currency]}
                                                              // onChange={handleChange}
                                                              type="number"
                                                              error={minAmtError}
                                                              helperText={minAmtError ? fieldError : ""}
                                                              variant="standard"
                                                            />
                                                          );
                                                        })}
                                                      </Box>
                                                    )}
                                                  </>
                                                );
                                              })()}
                                            </Box>
                                          </Grid>
                                          {(showPaydeeDynamicField(selectedPaymentHosts[index]) || showBSNDynamicField(selectedPaymentHosts[index])) && (
                                            <>
                                              <Grid item xs={4}>
                                                <TextField sx={{ m: 1, width: '80%' }} InputLabelProps={{ shrink: true }} type="text" label="Bank MID"
                                                  id={`payment.${index}.bank_mid`} name={`payment.${index}.bank_mid`}
                                                  value={values.payment[index].bank_mid ?? ""} onChange={handleChange} variant="standard" />
                                              </Grid>
                                              <Grid item xs={4}>
                                                <TextField sx={{ m: 1, width: '80%' }} InputLabelProps={{ shrink: true }} type="text" label="Bank TID"
                                                  id={`payment.${index}.bank_tid`} name={`payment.${index}.bank_tid`}
                                                  value={values.payment[index].bank_tid ?? ""} onChange={handleChange} variant="standard" />
                                              </Grid>
                                            </>
                                          )}
                                        </Grid>
                                      }

                                      <Grid container column={6} alignItems="flex-start">
                                        {(isShopeePayBrand && [PAYMENT_HOST_LIST.SHOPEEPAY_SG?.toLowerCase(), PAYMENT_HOST_LIST.SHOPEEPAY_TH?.toLowerCase()].includes(selectedPaymentHosts[index]?.toLowerCase())) ? (
                                          <>
                                            <Grid item xs={4}>
                                              <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 2, m: 1 }}>
                                                <FormControlLabel
                                                  control={<Checkbox disabled />}
                                                  label={<Typography sx={{ color: 'rgba(0, 0, 0, 1)' }}>Wallet*</Typography>}
                                                  name={`payment.${index}.shopeepay_wallet_enabled`}
                                                  checked={true}
                                                />
                                                <Grid container spacing={2} sx={{ mt: 1 }}>
                                                  <Grid item xs={6}>
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      InputProps={{
                                                        min: 0,
                                                        step: "any",
                                                        startAdornment: (
                                                          <InputAdornment position="start">
                                                            %
                                                          </InputAdornment>
                                                        ),
                                                      }}
                                                      label="Base Rate (Wallet)"
                                                      id={`payment.${index}.base_rate`}
                                                      name={`payment.${index}.base_rate`}
                                                      value={values.payment[index].base_rate}
                                                      onChange={(event) => {
                                                        const value = event.target.value;

                                                        // Allow empty value so user can clear the input
                                                        if (value === "") {
                                                          handleChange(event);
                                                          return;
                                                        }

                                                        // Prevent negative number
                                                        if (Number(value) < 0) {
                                                          return;
                                                        }

                                                        handleChange(event);
                                                      }}
                                                      onKeyDown={(event) => {
                                                        // Prevent negative, positive sign, and exponential input
                                                        if (["-", "+", "e", "E"].includes(event.key)) {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                      type="number"
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]?.base_rate &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.base_rate
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]?.base_rate &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.base_rate
                                                      }
                                                      variant="standard"
                                                    />
                                                  </Grid>

                                                  <Grid item xs={6}>
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      InputProps={{
                                                        startAdornment: (
                                                          <InputAdornment position="start">
                                                            %
                                                          </InputAdornment>
                                                        ),
                                                      }}
                                                      label="Markup Rate (Wallet)"
                                                      id={`payment.${index}.markup_rate`}
                                                      name={`payment.${index}.markup_rate`}
                                                      value={values.payment[index].markup_rate}
                                                      onChange={(event) => handleChange(event)}
                                                      type="number"
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]?.markup_rate &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.markup_rate
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]?.markup_rate &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.markup_rate
                                                      }
                                                      variant="standard"
                                                    />
                                                  </Grid>
                                                </Grid>
                                              </Box>
                                            </Grid>

                                            <Grid item xs={4}>
                                              <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 2, m: 1 }}>
                                                <FormControlLabel
                                                  control={<Checkbox />}
                                                  label="SPayLater"
                                                  name={`payment.${index}.shopeepay_spaylater_enabled`}
                                                  checked={Boolean(shopeeSpaylaterEnabled)}
                                                  onChange={() =>
                                                    handleShopeeToggle(
                                                      "shopeepay_spaylater_enabled",
                                                      [
                                                        `payment.${index}.spaylater_base_rate`,
                                                        `payment.${index}.spaylater_markup_rate`,
                                                      ]
                                                    )
                                                  }
                                                />
                                                {shopeeSpaylaterEnabled && (
                                                  <Grid container spacing={2} sx={{ mt: 1 }}>
                                                    <Grid item xs={6}>
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        InputProps={{
                                                          min: 0,
                                                          step: "any",
                                                          startAdornment: (
                                                            <InputAdornment position="start">
                                                              %
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        label="Base Rate (SPayLater)"
                                                        id={`payment.${index}.spaylater_base_rate`}
                                                        name={`payment.${index}.spaylater_base_rate`}
                                                        value={values.payment[index].spaylater_base_rate}
                                                        onChange={(event) => {
                                                          const value = event.target.value;

                                                          // Allow empty value so user can clear the input
                                                          if (value === "") {
                                                            handleChange(event);
                                                            return;
                                                          }

                                                          // Prevent negative number
                                                          if (Number(value) < 0) {
                                                            return;
                                                          }

                                                          handleChange(event);
                                                        }}
                                                        onKeyDown={(event) => {
                                                          // Prevent negative, positive sign, and exponential input
                                                          if (["-", "+", "e", "E"].includes(event.key)) {
                                                            event.preventDefault();
                                                          }
                                                        }}
                                                        type="number"
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]?.spaylater_base_rate &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.spaylater_base_rate
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]?.spaylater_base_rate &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.spaylater_base_rate
                                                        }
                                                        variant="standard"
                                                      />
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        InputProps={{
                                                          startAdornment: (
                                                            <InputAdornment position="start">
                                                              %
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        label="Markup Rate (SPayLater)"
                                                        id={`payment.${index}.spaylater_markup_rate`}
                                                        name={`payment.${index}.spaylater_markup_rate`}
                                                        value={values.payment[index].spaylater_markup_rate}
                                                        onChange={(event) => handleChange(event)}
                                                        type="number"
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]?.spaylater_markup_rate &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.spaylater_markup_rate
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]?.spaylater_markup_rate &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.spaylater_markup_rate
                                                        }
                                                        variant="standard"
                                                      />
                                                    </Grid>
                                                  </Grid>
                                                )}
                                              </Box>
                                            </Grid>

                                            <Grid item xs={4}>
                                              <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 2, m: 1 }}>
                                                <FormControlLabel
                                                  control={<Checkbox />}
                                                  label="Debit/Credit Card"
                                                  name={`payment.${index}.shopeepay_credit_enabled`}
                                                  checked={Boolean(shopeeCreditEnabled)}
                                                  onChange={() =>
                                                    handleShopeeToggle(
                                                      "shopeepay_credit_enabled",
                                                      [
                                                        `payment.${index}.credit_base_rate`,
                                                        `payment.${index}.credit_markup_rate`,
                                                      ]
                                                    )
                                                  }
                                                />
                                                {shopeeCreditEnabled && (
                                                  <Grid container spacing={2} sx={{ mt: 1 }}>
                                                    <Grid item xs={6}>
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        InputProps={{
                                                          min: 0,
                                                          step: "any",
                                                          startAdornment: (
                                                            <InputAdornment position="start">
                                                              %
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        label="Base Rate (Debit/Credit Card)"
                                                        id={`payment.${index}.credit_base_rate`}
                                                        name={`payment.${index}.credit_base_rate`}
                                                        value={values.payment[index].credit_base_rate}
                                                        onChange={(event) => {
                                                          const value = event.target.value;

                                                          // Allow empty value so user can clear the input
                                                          if (value === "") {
                                                            handleChange(event);
                                                            return;
                                                          }

                                                          // Prevent negative number
                                                          if (Number(value) < 0) {
                                                            return;
                                                          }

                                                          handleChange(event);
                                                        }}
                                                        onKeyDown={(event) => {
                                                          // Prevent negative, positive sign, and exponential input
                                                          if (["-", "+", "e", "E"].includes(event.key)) {
                                                            event.preventDefault();
                                                          }
                                                        }}
                                                        type="number"
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]?.credit_base_rate &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.credit_base_rate
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]?.credit_base_rate &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.credit_base_rate
                                                        }
                                                        variant="standard"
                                                      />
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        InputProps={{
                                                          startAdornment: (
                                                            <InputAdornment position="start">
                                                              %
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        label="Markup Rate (Debit/Credit Card)"
                                                        id={`payment.${index}.credit_markup_rate`}
                                                        name={`payment.${index}.credit_markup_rate`}
                                                        value={values.payment[index].credit_markup_rate}
                                                        onChange={(event) => handleChange(event)}
                                                        type="number"
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]?.credit_markup_rate &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.credit_markup_rate
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]?.credit_markup_rate &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.credit_markup_rate
                                                        }
                                                        variant="standard"
                                                      />
                                                    </Grid>
                                                  </Grid>
                                                )}
                                              </Box>
                                            </Grid>
                                            <Grid container xs={12}>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.merchant_ext_id`}
                                                  id={`payment.${index}.merchant_ext_id`}
                                                  validate={(value) => {
                                                    if (value?.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      id={`payment.${index}.merchant_ext_id`}
                                                      name={`payment.${index}.merchant_ext_id`}
                                                      label="Merchant Ext ID"
                                                      value={
                                                        values.payment[index]?.merchant_ext_id
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.merchant_ext_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.merchant_ext_id
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.merchant_ext_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.merchant_ext_id
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.store_ext_id`}
                                                  id={`payment.${index}.store_ext_id`}
                                                  validate={(value) => {
                                                    if (value?.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      id={`payment.${index}.store_ext_id`}
                                                      name={`payment.${index}.store_ext_id`}
                                                      label="Store Ext ID"
                                                      value={
                                                        values.payment[index]?.store_ext_id
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.store_ext_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.store_ext_id
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]?.store_ext_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.store_ext_id
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                            </Grid>

                                          </>
                                        ) : showAllinpayDynamicField(selectedPaymentHosts[index]) ? (
                                          <AllinpayFields
                                            index={index}
                                            values={values}
                                            handleChange={handleChange}
                                            touched={touched}
                                            errors={errors}
                                            selectedPaymentHost={selectedPaymentHosts[index]}
                                            section="rates"
                                          />
                                        ) : (
                                          <>
                                            <Grid item xs={2}>
                                              <TextField
                                                required
                                                sx={{ m: 1 }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                InputProps={{
                                                  startAdornment: (
                                                    <InputAdornment position="start">
                                                      %
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                inputProps={{
                                                  min: 0,
                                                  step: "any",
                                                }}
                                                label="Base Rate"
                                                id={`payment.${index}.base_rate`}
                                                name={`payment.${index}.base_rate`}
                                                value={values.payment[index].base_rate}
                                                onChange={(event) => {
                                                  const value = event.target.value;

                                                  // Allow empty value so user can clear the input
                                                  if (value === "") {
                                                    handleChange(event);
                                                    return;
                                                  }

                                                  // Prevent negative number
                                                  if (Number(value) < 0) {
                                                    return;
                                                  }

                                                  handleChange(event);
                                                }}
                                                onKeyDown={(event) => {
                                                  // Prevent negative, positive sign, and exponential input
                                                  if (["-", "+", "e", "E"].includes(event.key)) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                type="number"
                                                error={Boolean(
                                                  touched.payment &&
                                                    touched?.payment[index]?.base_rate &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.base_rate
                                                )}
                                                helperText={
                                                  touched.payment &&
                                                  touched?.payment[index]?.base_rate &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.base_rate
                                                }
                                                variant="standard"
                                              />
                                            </Grid>

                                            <Grid item xs={2}>
                                              <TextField
                                                required
                                                sx={{ m: 1 }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                InputProps={{
                                                  startAdornment: (
                                                    <InputAdornment position="start">
                                                      %
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                label="Markup Rate"
                                                id={`payment.${index}.markup_rate`}
                                                name={`payment.${index}.markup_rate`}
                                                value={values.payment[index].markup_rate}
                                                onChange={(event) => handleChange(event)}
                                                type="number"
                                                error={Boolean(
                                                  touched.payment &&
                                                    touched?.payment[index]?.markup_rate &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.markup_rate
                                                )}
                                                helperText={
                                                  touched.payment &&
                                                  touched?.payment[index]?.markup_rate &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.markup_rate
                                                }
                                                variant="standard"
                                              />
                                            </Grid>
                                          </>
                                        )}

                                        {/* Foreign rates */}
                                        {
                                          (selectedPaymentHosts[index] === PAYMENT_HOST_LIST.FIUU || selectedPaymentHosts[index] === PAYMENT_HOST_LIST.FIUU_DIRECT_PF) && (
                                            <>
                                              <Grid item xs={2}>
                                                <TextField
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  InputProps={{
                                                    startAdornment: (
                                                      <InputAdornment position="start">
                                                        %
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                  label="Base Rate (Foreign Card)"
                                                  id={`payment.${index}.base_rate_foreign`}
                                                  name={`payment.${index}.base_rate_foreign`}
                                                  value={values.payment[index].base_rate_foreign}
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]?.base_rate_foreign &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.base_rate_foreign
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]?.base_rate_foreign &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.base_rate_foreign
                                                  }
                                                  variant="standard"
                                                  type="number"
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <TextField
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  InputProps={{
                                                    startAdornment: (
                                                      <InputAdornment position="start">
                                                        %
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                  label="Markup Rate (Foreign Card)"
                                                  id={`payment.${index}.markup_rate_foreign`}
                                                  name={`payment.${index}.markup_rate_foreign`}
                                                  value={values.payment[index].markup_rate_foreign}
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]?.markup_rate_foreign &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.markup_rate_foreign
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]?.markup_rate_foreign &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.markup_rate_foreign
                                                  }
                                                  variant="standard"
                                                  type="number"
                                                />
                                              </Grid>
                                            </>
                                          )
                                        }
                                        {/* End Foreign rates */}

                                        {[PAYMENT_HOST_LIST.DBS, PAYMENT_HOST_LIST.SCB].includes(selectedPaymentHosts[index]) &&
                                          <Grid item xs={4}>
                                            <Box sx={{ m: 1 }}>
                                              <Field
                                                name={`payment.${index}.paynow_descriptor_id`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    sx={{ pt: 0.5 }}
                                                    required
                                                    variant="standard"
                                                    name={`payment.${index}.paynow_descriptor_id`}
                                                    select
                                                    label="PayNow Descriptor"
                                                    size="small"
                                                    fullWidth
                                                    value={values.payment[index].paynow_descriptor_id}
                                                    onChange={(e, child) => {
                                                      setFieldValue(`payment.${index}.ref_2`, child.props["dataPayNowSuffix"]);
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]?.paynow_descriptor_id &&
                                                      errors.payment &&
                                                      errors?.payment?.[index]?.paynow_descriptor_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]?.paynow_descriptor_id &&
                                                      errors.payment &&
                                                      errors?.payment?.[index]?.paynow_descriptor_id
                                                    }
                                                  >
                                                    {paynowDescriptor[selectedPaymentHosts[index]]?.map((item) => (
                                                      <MenuItem
                                                        key={item.id}
                                                        value={item.id}
                                                        dataPayNowSuffix={item.paynow_proxy_suffix}
                                                      >
                                                        {item.name} - {item.paynow_proxy_suffix}
                                                      </MenuItem>
                                                    ))
                                                      || UnavailableOptionItem}
                                                  </TextField>
                                                )}
                                              />
                                            </Box>
                                          </Grid>
                                        }

                                        {(selectedPaymentHosts[index] === PAYMENT_HOST_LIST.SCB || selectedPaymentHosts[index] === PAYMENT_HOST_LIST.DBS) &&
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.ref_2`}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  disabled
                                                  label="PayNow Suffix"
                                                  name={`payment.${index}.ref_2`}
                                                  value={values.payment[index].ref_2}
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                        }

                                        {selectedPaymentHosts[index] === PAYMENT_HOST_LIST.LIQUIDNET && (
                                          <>
                                            <Grid item xs={2}>
                                              <Box sx={{ m: 1 }}>
                                                <Field
                                                  name={`payment.${index}.payee`}
                                                  validate={(value) => {
                                                    if (!value || value === LIQUID_PAYEE_PREFIX) {
                                                      return "Payee is required for liquidnet";
                                                    }
                                                    if (value.length !== 15) {
                                                      return "Payee must be exactly 15 characters (" + LIQUID_PAYEE_PREFIX + " + 8 characters)";
                                                    }
                                                    return null;
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      size="small"
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="Payee"
                                                      name={`payment.${index}.payee`}
                                                      value={values.payment[index].payee?.replace(LIQUID_PAYEE_PREFIX, '') || ''}
                                                      onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value.length <= 8) {
                                                          setFieldValue(`payment.${index}.payee`, LIQUID_PAYEE_PREFIX + value);
                                                        }
                                                      }}
                                                      variant="standard"
                                                      placeholder=""
                                                      InputProps={{
                                                        startAdornment: (
                                                          <InputAdornment position="start">
                                                            <span
                                                              style={{
                                                                fontFamily: 'monospace',
                                                                fontSize: '15px',
                                                                fontWeight: 'normal',
                                                                color: 'inherit',
                                                                paddingBottom: '2px'
                                                              }}
                                                            >
                                                              {LIQUID_PAYEE_PREFIX}
                                                            </span>
                                                          </InputAdornment>
                                                        ),
                                                      }}
                                                      inputProps={{
                                                        maxLength: 8,
                                                        style: { fontFamily: 'monospace' }
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]?.payee &&
                                                        errors?.payment?.[index]?.payee
                                                      )}
                                                    />
                                                  )}
                                                />
                                              </Box>
                                            </Grid>
                                          </>
                                        )}

                                        {selectedPaymentHosts[index] === PAYMENT_HOST_LIST.LINEPAY && (
                                          <Grid item xs={2}>
                                            <Box sx={{ m: 1 }}>
                                              <Field
                                                name={`payment.${index}.line_pay_merchant_id`}
                                                validate={(value) => {
                                                  if (!value) return "LINE Pay Merchant ID is required for PromptPay";
                                                  if (value.length > 100) return "LINE Pay Merchant ID must be at most 100 characters";
                                                  return null;
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    size="small"
                                                    InputLabelProps={{ shrink: true }}
                                                    label="LINE Pay Merchant ID"
                                                    name={`payment.${index}.line_pay_merchant_id`}
                                                    value={values.payment[index].line_pay_merchant_id ?? ""}
                                                    onChange={(e) => setFieldValue(`payment.${index}.line_pay_merchant_id`, e.target.value)}
                                                    variant="standard"
                                                    inputProps={{ maxLength: 100 }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]?.line_pay_merchant_id &&
                                                      errors?.payment?.[index]?.line_pay_merchant_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]?.line_pay_merchant_id &&
                                                      errors?.payment?.[index]?.line_pay_merchant_id
                                                    }
                                                  />
                                                )}
                                              />
                                            </Box>
                                          </Grid>
                                        )}

                                        {selectedPaymentHosts[index] === PAYMENT_HOST_LIST.FOMOPAY && (
                                          <Grid item xs={2}>
                                            <Box sx={{ m: 1 }}>
                                              <Field
                                                name={`payment.${index}.sub_mid`}
                                                validate={(value) => {
                                                  if (value && value.length > 128) return "Sub MID must be at most 128 characters";
                                                  return null;
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    size="small"
                                                    InputLabelProps={{ shrink: true }}
                                                    label="Sub MID"
                                                    name={`payment.${index}.sub_mid`}
                                                    value={values.payment[index].sub_mid ?? ""}
                                                    onChange={(e) =>
                                                      setFieldValue(`payment.${index}.sub_mid`, e.target.value)
                                                    }
                                                    variant="standard"
                                                    inputProps={{ maxLength: 128 }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]?.sub_mid &&
                                                      errors?.payment?.[index]?.sub_mid
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]?.sub_mid &&
                                                      errors?.payment?.[index]?.sub_mid
                                                    }
                                                  />
                                                )}
                                              />
                                            </Box>
                                          </Grid>
                                        )}

                                        {selectedPaymentHosts[index] === PAYMENT_HOST_LIST.ATOME && (
                                          <>
                                            <Grid item xs={2}>
                                              <Box sx={{ m: 1 }}>
                                                <Field
                                                  name={`payment.${index}.atome_username`}
                                                  validate={(value) => {
                                                    if (!showAtomeDynamicField(selectedPaymentHosts[index])) return null;
                                                    const v = value != null ? String(value).trim() : "";
                                                    if (!v) return "Username is required for Atome";
                                                    if (v.length > 50) return "Username must be at most 50 characters";
                                                    return null;
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      size="small"
                                                      InputLabelProps={{ shrink: true }}
                                                      label="Atome username"
                                                      name={`payment.${index}.atome_username`}
                                                      value={values.payment[index].atome_username ?? ""}
                                                      onChange={(e) =>
                                                        setFieldValue(`payment.${index}.atome_username`, e.target.value)
                                                      }
                                                      variant="standard"
                                                      inputProps={{ maxLength: 50 }}
                                                      autoComplete="off"
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]?.atome_username &&
                                                        errors?.payment?.[index]?.atome_username
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]?.atome_username &&
                                                        errors?.payment?.[index]?.atome_username
                                                      }
                                                    />
                                                  )}
                                                />
                                              </Box>
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Box sx={{ m: 1 }}>
                                                <Field
                                                  name={`payment.${index}.atome_password`}
                                                  validate={(value) => {
                                                    if (!showAtomeDynamicField(selectedPaymentHosts[index])) return null;
                                                    const v = value != null ? String(value).trim() : "";
                                                    if (!v) return "Password is required for Atome";
                                                    if (v.length > 255) return "Password must be at most 255 characters";
                                                    return null;
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      size="small"
                                                      type="text"
                                                      InputLabelProps={{ shrink: true }}
                                                      label="Atome password"
                                                      name={`payment.${index}.atome_password`}
                                                      value={values.payment[index].atome_password ?? ""}
                                                      onChange={(e) =>
                                                        setFieldValue(`payment.${index}.atome_password`, e.target.value)
                                                      }
                                                      variant="standard"
                                                      inputProps={{ maxLength: 255 }}
                                                      autoComplete="off"
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]?.atome_password &&
                                                        errors?.payment?.[index]?.atome_password
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]?.atome_password &&
                                                        errors?.payment?.[index]?.atome_password
                                                      }
                                                    />
                                                  )}
                                                />
                                              </Box>
                                            </Grid>
                                          </>
                                        )}

                                        {selectedPaymentHosts[index] &&
                                          showGrabPayDynamicField(
                                            selectedPaymentHosts[index]
                                          ) &&
                                          !selectedPaymentHosts[index]?.includes(PAYMENT_HOST_LIST.GRABPAY_GW2) && (
                                            <>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.grabpay_merchant_id`}
                                                  id={`payment.${index}.grabpay_merchant_id`}
                                                  validate={(value) => {
                                                    if (value?.trim() === '') {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="GrabPay Store ID"
                                                      id={`payment.${index}.grabpay_merchant_id`}
                                                      name={`payment.${index}.grabpay_merchant_id`}
                                                      value={
                                                        values.payment[index]
                                                          .grabpay_merchant_id
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.grabpay_merchant_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.grabpay_merchant_id
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.grabpay_merchant_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.grabpay_merchant_id
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.grabpay_terminal_id`}
                                                  id={`payment.${index}.grabpay_terminal_id`}
                                                  validate={(value) => {
                                                    if (value?.trim() === '') {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="GrabPay Terminal ID"
                                                      id={`payment.${index}.grabpay_terminal_id`}
                                                      name={`payment.${index}.grabpay_terminal_id`}
                                                      value={
                                                        values.payment[index]
                                                          .grabpay_terminal_id
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.grabpay_terminal_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.grabpay_terminal_id
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.grabpay_terminal_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.grabpay_terminal_id
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              {!selectedPaymentHosts[index]
                                                ?.toLowerCase()
                                                ?.includes(PAYMENT_HOST_LIST.GRABPAY_V1) && (
                                                  <Grid item xs={2}>
                                                    <Field
                                                      name={`payment.${index}.payment_expiry_time`}
                                                      id={`payment.${index}.payment_expiry_time`}
                                                      validate={(value) => {
                                                        if (value?.length === 0) {
                                                          return "This field is required";
                                                        }
                                                      }}
                                                      render={({ field }) => (
                                                        <TextField
                                                          required
                                                          sx={{ m: 1 }}
                                                          InputLabelProps={{
                                                            shrink: true,
                                                          }}
                                                          inputProps={{
                                                            min: 0,
                                                            step: "any",
                                                          }}
                                                          type="number"
                                                          label="Payment Expiry Time (Min)"
                                                          id={`payment.${index}.payment_expiry_time`}
                                                          name={`payment.${index}.payment_expiry_time`}
                                                          value={
                                                            values.payment[index]
                                                              .payment_expiry_time
                                                          }
                                                          onChange={(event) => {
                                                            const value = event.target.value;

                                                            // Allow empty value so user can clear the input
                                                            if (value === "") {
                                                              handleChange(event);
                                                              return;
                                                            }

                                                            // Prevent negative number
                                                            if (Number(value) < 0) {
                                                              return;
                                                            }

                                                            handleChange(event);
                                                          }}
                                                          onKeyDown={(event) => {
                                                            // Prevent negative, positive sign, and exponential input
                                                            if (["-", "+", "e", "E"].includes(event.key)) {
                                                              event.preventDefault();
                                                            }
                                                          }}
                                                          error={Boolean(
                                                            touched.payment &&
                                                            touched?.payment[index]
                                                              ?.payment_expiry_time &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.payment_expiry_time
                                                          )}
                                                          helperText={
                                                            touched.payment &&
                                                            touched?.payment[index]
                                                              ?.payment_expiry_time &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.payment_expiry_time
                                                          }
                                                          variant="standard"
                                                        />
                                                      )}
                                                    />
                                                  </Grid>
                                                )}
                                              {!selectedPaymentHosts[index]
                                                ?.toLowerCase()
                                                ?.includes(PAYMENT_HOST_LIST.GRABPAY_V1) && (
                                                  <>
                                                    <Grid item xs={2}>
                                                      <Field
                                                        name={`payment.${index}.min_amt_postpaid`}
                                                        id={`payment.${index}.min_amt_postpaid`}
                                                        validate={(value) => {
                                                          if (values.payment[index].postpaid) {
                                                            if (value?.length === 0) {
                                                              return "This field is required";
                                                            }
                                                          }
                                                        }}
                                                        render={({ field }) => (
                                                          <TextField
                                                            required={values.payment[index]?.postpaid}
                                                            sx={{ m: 1 }}
                                                            InputLabelProps={{
                                                              shrink: true,
                                                            }}
                                                            InputProps={{
                                                              min: 0,
                                                              step: "any",
                                                              startAdornment: (
                                                                <InputAdornment position="start">
                                                                  $
                                                                </InputAdornment>
                                                              ),
                                                            }}
                                                            type="number"
                                                            label="Min Amount (Postpaid)"
                                                            id={`payment.${index}.min_amt_postpaid`}
                                                            name={`payment.${index}.min_amt_postpaid`}
                                                            value={values.payment[index].min_amt_postpaid}
                                                            onChange={(event) => {
                                                              const value = event.target.value;

                                                              // Allow empty value so user can clear the input
                                                              if (value === "") {
                                                                handleChange(event);
                                                                return;
                                                              }

                                                              // Prevent negative number
                                                              if (Number(value) < 0) {
                                                                return;
                                                              }

                                                              handleChange(event);
                                                            }}
                                                            onKeyDown={(event) => {
                                                              // Prevent negative, positive sign, and exponential input
                                                              if (["-", "+", "e", "E"].includes(event.key)) {
                                                                event.preventDefault();
                                                              }
                                                            }}
                                                            error={Boolean(
                                                              touched.payment &&
                                                              touched?.payment[index]
                                                                ?.min_amt_postpaid &&
                                                              errors.payment &&
                                                              errors?.payment[index]
                                                                ?.min_amt_postpaid
                                                            )}
                                                            helperText={
                                                              touched.payment &&
                                                              touched?.payment[index]
                                                                ?.min_amt_postpaid &&
                                                              errors.payment &&
                                                              errors?.payment[index]
                                                                ?.min_amt_postpaid
                                                            }
                                                            variant="standard"
                                                          />
                                                        )}
                                                      />
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                      <Field
                                                        name={`payment.${index}.min_amt_installment_4`}
                                                        id={`payment.${index}.min_amt_installment_4`}
                                                        validate={(value) => {
                                                          if (values.payment[index].installment_4) {
                                                            if (value?.length === 0) {
                                                              return "This field is required";
                                                            }
                                                          }
                                                        }}
                                                        render={({ field }) => (
                                                          <TextField
                                                            required={!!values.payment[index]?.installment_4}
                                                            sx={{ m: 1 }}
                                                            InputLabelProps={{
                                                              shrink: true,
                                                            }}
                                                            InputProps={{
                                                              min: 0,
                                                              step: "any",
                                                              startAdornment: (
                                                                <InputAdornment position="start">
                                                                  $
                                                                </InputAdornment>
                                                              ),
                                                            }}
                                                            type="number"
                                                            label="Min Amount (Installment)"
                                                            id={`payment.${index}.min_amt_installment_4`}
                                                            name={`payment.${index}.min_amt_installment_4`}
                                                            value={values.payment[index].min_amt_installment_4}
                                                            onChange={(event) => {
                                                              const value = event.target.value;

                                                              // Allow empty value so user can clear the input
                                                              if (value === "") {
                                                                handleChange(event);
                                                                return;
                                                              }

                                                              // Prevent negative number
                                                              if (Number(value) < 0) {
                                                                return;
                                                              }

                                                              handleChange(event);
                                                            }}
                                                            onKeyDown={(event) => {
                                                              // Prevent negative, positive sign, and exponential input
                                                              if (["-", "+", "e", "E"].includes(event.key)) {
                                                                event.preventDefault();
                                                              }
                                                            }}
                                                            error={Boolean(
                                                              touched.payment &&
                                                              touched?.payment[index]
                                                                ?.min_amt_installment_4 &&
                                                              errors.payment &&
                                                              errors?.payment[index]
                                                                ?.min_amt_installment_4
                                                            )}
                                                            helperText={
                                                              touched.payment &&
                                                              touched?.payment[index]
                                                                ?.min_amt_installment_4 &&
                                                              errors.payment &&
                                                              errors?.payment[index]
                                                                ?.min_amt_installment_4
                                                            }
                                                            variant="standard"
                                                          />
                                                        )}
                                                      />
                                                    </Grid>
                                                  </>
                                                )}
                                            </>
                                          )}
                                        {selectedPaymentHosts[index] &&
                                          showTouchNGoDynamicField(
                                            selectedPaymentHosts[index]
                                          ) && (
                                            <>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.touchngo_expiry_time`}
                                                  id={`payment.${index}.touchngo_expiry_time`}
                                                  validate={(value) => {
                                                    if (value?.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="Expiry Time (Min)"
                                                      id={`payment.${index}.touchngo_expiry_time`}
                                                      name={`payment.${index}.touchngo_expiry_time`}
                                                      value={
                                                        values.payment[index]
                                                          .touchngo_expiry_time
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.touchngo_expiry_time &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.touchngo_expiry_time
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.touchngo_expiry_time &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.touchngo_expiry_time
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.touchngo_merchant_id`}
                                                  id={`payment.${index}.touchngo_merchant_id`}
                                                  validate={(value) => {
                                                    if (value?.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="TouchNGo Merchant ID"
                                                      id={`payment.${index}.touchngo_merchant_id`}
                                                      name={`payment.${index}.touchngo_merchant_id`}
                                                      value={
                                                        values.payment[index].touchngo_merchant_id
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.touchngo_merchant_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.touchngo_merchant_id
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.touchngo_merchant_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.touchngo_merchant_id
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.touchngo_client_id`}
                                                  id={`payment.${index}.touchngo_client_id`}
                                                  validate={(value) => {
                                                    if (value?.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="TouchNGo Client ID"
                                                      id={`payment.${index}.touchngo_client_id`}
                                                      name={`payment.${index}.touchngo_client_id`}
                                                      value={
                                                        values.payment[index].touchngo_client_id
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.touchngo_client_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.touchngo_client_id
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.touchngo_client_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.touchngo_client_id
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.touchngo_client_secret`}
                                                  id={`payment.${index}.touchngo_client_secret`}
                                                  validate={(value) => {
                                                    if (value.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="TouchNGo Client Secret"
                                                      id={`payment.${index}.touchngo_client_secret`}
                                                      name={`payment.${index}.touchngo_client_secret`}
                                                      value={
                                                        values.payment[index].touchngo_client_secret
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.touchngo_client_secret &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.touchngo_client_secret
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.touchngo_client_secret &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.touchngo_client_secret
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.is_autodebit_enabled`}
                                                  id={`payment.${index}.is_autodebit_enabled`}
                                                  render={({ field }) => (
                                                    <FormControlLabel
                                                      sx={{ m: 1 }}
                                                      control={
                                                        <Checkbox
                                                          id={`payment.${index}.is_autodebit_enabled`}
                                                          name={`payment.${index}.is_autodebit_enabled`}
                                                          checked={Boolean(
                                                            values.payment[index]
                                                              .is_autodebit_enabled
                                                          )}
                                                          onChange={(e) => {
                                                            setFieldValue(
                                                              `payment.${index}.is_autodebit_enabled`,
                                                              e.target.checked
                                                            );
                                                            if (!e.target.checked) {
                                                              setFieldValue(
                                                                `payment.${index}.autodebit_amount`,
                                                                ""
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      }
                                                      label="Enable AutoDebit"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              {values.payment[index]
                                                .is_autodebit_enabled && (
                                                <Grid item xs={2}>
                                                  <Field
                                                    name={`payment.${index}.autodebit_amount`}
                                                    id={`payment.${index}.autodebit_amount`}
                                                    validate={(value) => {
                                                      if (
                                                        values.payment[index]
                                                          .is_autodebit_enabled &&
                                                        (value === undefined ||
                                                          value === null ||
                                                          value === "")
                                                      ) {
                                                        return "AutoDebit Amount is required";
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        type="number"
                                                        label="AutoDebit Amount"
                                                        id={`payment.${index}.autodebit_amount`}
                                                        name={`payment.${index}.autodebit_amount`}
                                                        value={
                                                          values.payment[index]
                                                            .autodebit_amount
                                                        }
                                                        onChange={(e) => {
                                                          handleChange(e);
                                                        }}
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]
                                                            ?.autodebit_amount &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.autodebit_amount
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]
                                                            ?.autodebit_amount &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.autodebit_amount
                                                        }
                                                        variant="standard"
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                              )}
                                            </>
                                          )}

                                        {selectedPaymentHosts[index] &&
                                          showDashDynamicField(
                                            selectedPaymentHosts[index]
                                          ) && (
                                            <>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.counter_id`}
                                                  id={`payment.${index}.counter_id`}
                                                  validate={(value) => {
                                                    if (!value || value.trim() === '') {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="Counter ID"
                                                      id={`payment.${index}.counter_id`}
                                                      name={`payment.${index}.counter_id`}
                                                      value={
                                                        values.payment[index].counter_id || ""
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.counter_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.counter_id
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.counter_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.counter_id
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.counter_msisdn`}
                                                  id={`payment.${index}.counter_msisdn`}
                                                  validate={(value) => {
                                                    if (!value || value.trim() === '') {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="Counter MSISDN"
                                                      id={`payment.${index}.counter_msisdn`}
                                                      name={`payment.${index}.counter_msisdn`}
                                                      value={
                                                        values.payment[index].counter_msisdn
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.counter_msisdn &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.counter_msisdn
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.counter_msisdn &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.counter_msisdn
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.counter_pin`}
                                                  id={`payment.${index}.counter_pin`}
                                                  validate={(value) => {
                                                    if (!value || value.trim() === '') {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="Counter PIN"
                                                      id={`payment.${index}.counter_pin`}
                                                      name={`payment.${index}.counter_pin`}
                                                      value={
                                                        values.payment[index].counter_pin
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.counter_pin &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.counter_pin
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.counter_pin &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.counter_pin
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                            </>
                                          )}
                                        {selectedPaymentHosts[index] &&
                                          showAliPayDynamicField(
                                            selectedPaymentHosts[index]
                                          ) && (
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.store_id`}
                                                id={`payment.${index}.store_id`}
                                                validate={(value) => {
                                                  if (!value || value.trim() === "") {
                                                    return "Store ID is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    label="Store ID"
                                                    id={`payment.${index}.store_id`}
                                                    name={`payment.${index}.store_id`}
                                                    value={values.payment[index].store_id || ""}
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]?.store_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.store_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]?.store_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.store_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                          )}
                                          
                                        {selectedPaymentHosts[index] &&
                                          showWeChatDynamicField(
                                            selectedPaymentHosts[index]
                                          ) && (
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.partner_id`}
                                                id={`payment.${index}.partner_id`}
                                                validate={(value) => {
                                                  if (!value || value.trim() === "") {
                                                    return "Partner ID is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    label="Partner ID"
                                                    id={`payment.${index}.partner_id`}
                                                    name={`payment.${index}.partner_id`}
                                                    value={values.payment[index].partner_id || ""}
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]?.partner_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.partner_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]?.partner_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.partner_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                          )}

                                        {selectedPaymentHosts[index] &&
                                          selectedPaymentHosts[index].includes(
                                            PAYMENT_HOST_LIST.WORLDPAY
                                          ) && (
                                            <>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.pf_id`}
                                                  id={`payment.${index}.pf_id`}
                                                  validate={(value) => {
                                                    if (value.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="Sub Merchant pf id"
                                                      id={`payment.${index}.pf_id`}
                                                      name={`payment.${index}.pf_id`}
                                                      value={
                                                        values.payment[index].pf_id
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.pf_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.pf_id
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.pf_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.pf_id
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.sub_name`}
                                                  id={`payment.${index}.sub_name`}
                                                  validate={(value) => {
                                                    if (value.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="Sub Merchant Name"
                                                      id={`payment.${index}.sub_name`}
                                                      name={`payment.${index}.sub_name`}
                                                      value={
                                                        values.payment[index].sub_name
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.sub_name &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.sub_name
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.sub_name &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.sub_name
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.sub_id`}
                                                  id={`payment.${index}.sub_id`}
                                                  validate={(value) => {
                                                    if (value.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="Sub Merchant Id"
                                                      id={`payment.${index}.sub_id`}
                                                      name={`payment.${index}.sub_id`}
                                                      value={
                                                        values.payment[index].sub_id
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.sub_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.sub_id
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.sub_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.sub_id
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.sub_street`}
                                                  id={`payment.${index}.sub_street`}
                                                  validate={(value) => {
                                                    if (value.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="Sub Merchant Street"
                                                      id={`payment.${index}.sub_street`}
                                                      name={`payment.${index}.sub_street`}
                                                      value={
                                                        values.payment[index]
                                                          .sub_street
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.sub_street &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.sub_street
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.sub_street &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.sub_street
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.sub_city`}
                                                  id={`payment.${index}.sub_city`}
                                                  validate={(value) => {
                                                    if (value.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="Sub Merchant City"
                                                      id={`payment.${index}.sub_city`}
                                                      name={`payment.${index}.sub_city`}
                                                      value={
                                                        values.payment[index]
                                                          ?.sub_city
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.sub_city &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.sub_city
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.sub_city &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.sub_city
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.sub_country_code`}
                                                  id={`payment.${index}.sub_country_code`}
                                                  validate={(value) => {
                                                    if (value.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1, width: "100%" }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      select
                                                      label="Sub Merchant Country Code"
                                                      id={`payment.${index}.sub_country_code`}
                                                      name={`payment.${index}.sub_country_code`}
                                                      value={
                                                        values.payment[index]
                                                          .sub_country_code
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.sub_country_code &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.sub_country_code
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.sub_country_code &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.sub_country_code
                                                      }
                                                      variant="standard"
                                                    >
                                                      {
                                                        SUB_MERCHANT_COUNTRY_CODE.map((item) => (
                                                          <MenuItem
                                                            key={item.id}
                                                            value={item.id}
                                                          >
                                                            {item.id} - {item.name}
                                                          </MenuItem>
                                                        ))
                                                      }
                                                    </TextField>
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.sub_postal_code`}
                                                  id={`payment.${index}.sub_postal_code`}
                                                  validate={(value) => {
                                                    if (value.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      id={`payment.${index}.sub_postal_code`}
                                                      name={`payment.${index}.sub_postal_code`}
                                                      label="Sub Merchant Postal Code"
                                                      value={
                                                        values.payment[index]
                                                          .sub_postal_code
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.sub_postal_code &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.sub_postal_code
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.sub_postal_code &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.sub_postal_code
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.mcc`}
                                                  id={`payment.${index}.mcc`}
                                                  validate={(value) => {
                                                    if (value.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      id={`payment.${index}.mcc`}
                                                      name={`payment.${index}.mcc`}
                                                      label="MCC"
                                                      value={
                                                        values.payment[index].mcc
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.mcc &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.mcc
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.mcc &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.mcc
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              {values.payment[index].enable_vis && (
                                                <Grid item xs={2}>
                                                  <Field
                                                    name={`payment.${index}.partner_merchant_reference_id`}
                                                    id={`payment.${index}.partner_merchant_reference_id`}
                                                    validate={(value) => {
                                                      if (value.length < 1) {
                                                        return "This field is required";
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        label="Partner Merchant Reference id"
                                                        id={`payment.${index}.partner_merchant_reference_id`}
                                                        name={`payment.${index}.partner_merchant_reference_id`}
                                                        value={
                                                          values.payment[index]
                                                            .partner_merchant_reference_id
                                                        }
                                                        onChange={(e) => {
                                                          handleChange(e);
                                                        }}
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]
                                                            ?.partner_merchant_reference_id &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.partner_merchant_reference_id
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]
                                                            ?.partner_merchant_reference_id &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.partner_merchant_reference_id
                                                        }
                                                        variant="standard"
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                              )}
                                              {/* {values.payment[index].enable_vis && (
                                          <Grid item xs={4}>
                                            <Box sx={{ m: 1 }}>
                                              <Field
                                                id={`payment.${index}.currency_list`}
                                                name={`payment.${index}.currency_list`}
                                                options={allowedCurrency.map(
                                                  (method) => ({
                                                    value: method.id || "",
                                                    label:
                                                      method.currency || "",
                                                  })
                                                )}
                                                placeholder="Select multi currencies..."
                                                component={MultiSelectField}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "At least one currency must be selected";
                                                  }
                                                }}
                                              />
                                              {touched.payment &&
                                                touched?.payment[index]
                                                  ?.currency_list &&
                                                errors.payment &&
                                                errors?.payment[index]
                                                  ?.currency_list ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    mt: "2px",
                                                  }}
                                                >
                                                  {
                                                    errors.payment[index]
                                                      ?.currency_list
                                                  }
                                                </div>
                                              ) : null}
                                            </Box>
                                          </Grid>
                                        )} */}
                                              {values.payment[index].enable_vis && (
                                                <Grid item xs={2}>
                                                  <FormControlLabel
                                                    sx={{ m: 1 }}
                                                    type="checkbox"
                                                    id={`payment.${index}.enabled_3ds`}
                                                    name={`payment.${index}.enabled_3ds`}
                                                    checked={
                                                      values.payment[index]
                                                        .enabled_3ds
                                                    }
                                                    onChange={() =>
                                                      setFieldValue(
                                                        `payment.${index}.enabled_3ds`,
                                                        !values.payment[index]
                                                          .enabled_3ds
                                                      )
                                                    }
                                                    control={<Checkbox />}
                                                    label="Enable 3DS"
                                                  />
                                                </Grid>
                                              )}
                                              {!values.payment[index]
                                                .default_bin_routing && (
                                                  <Grid item xs={2}>
                                                    <Field
                                                      name={`payment.${index}.min_card_range`}
                                                      id={`payment.${index}.min_card_range`}
                                                      validate={(value) => {
                                                        if (value.length < 1) {
                                                          return "This field is required";
                                                        }
                                                      }}
                                                      render={({ field }) => (
                                                        <TextField
                                                          required
                                                          sx={{ m: 1 }}
                                                          InputLabelProps={{
                                                            shrink: true,
                                                          }}
                                                          InputProps={{
                                                            startAdornment: (
                                                              <InputAdornment position="start">
                                                                $
                                                              </InputAdornment>
                                                            ),
                                                          }}
                                                          label="Min Card Range"
                                                          id={`payment.${index}.min_card_range`}
                                                          name={`payment.${index}.min_card_range`}
                                                          value={
                                                            values.payment[index]
                                                              .min_card_range
                                                          }
                                                          onChange={(e) => {
                                                            handleChange(e);
                                                          }}
                                                          error={Boolean(
                                                            touched.payment &&
                                                            touched?.payment[index]
                                                              ?.min_card_range &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.min_card_range
                                                          )}
                                                          helperText={
                                                            touched.payment &&
                                                            touched.payment[index]
                                                              ?.min_card_range &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.min_card_range
                                                          }
                                                          variant="standard"
                                                        />
                                                      )}
                                                    />
                                                  </Grid>
                                                )}
                                              {!values.payment[index]
                                                .default_bin_routing && (
                                                  <Grid item xs={2}>
                                                    <Field
                                                      name={`payment.${index}.max_card_range`}
                                                      id={`payment.${index}.max_card_range`}
                                                      validate={(value) => {
                                                        if (value.length < 1) {
                                                          return "This field is required";
                                                        }
                                                      }}
                                                      render={({ field }) => (
                                                        <TextField
                                                          required
                                                          sx={{ m: 1 }}
                                                          InputLabelProps={{
                                                            shrink: true,
                                                          }}
                                                          InputProps={{
                                                            startAdornment: (
                                                              <InputAdornment position="start">
                                                                $
                                                              </InputAdornment>
                                                            ),
                                                          }}
                                                          label="Max Card Range"
                                                          id={`payment.${index}.max_card_range`}
                                                          name={`payment.${index}.max_card_range`}
                                                          value={
                                                            values.payment[index]
                                                              .max_card_range
                                                          }
                                                          onChange={(e) => {
                                                            handleChange(e);
                                                          }}
                                                          error={Boolean(
                                                            touched.payment &&
                                                            touched?.payment[index]
                                                              ?.max_card_range &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.max_card_range
                                                          )}
                                                          helperText={
                                                            touched.payment &&
                                                            touched?.payment[index]
                                                              ?.max_card_range &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.max_card_range
                                                          }
                                                          variant="standard"
                                                        />
                                                      )}
                                                    />
                                                  </Grid>
                                                )}
                                            </>
                                          )}

                                        {paymentMethod?.[index]?.toLowerCase() === "card" &&
                                          !showCybersourceDynamicField(selectedPaymentHosts[index]) && (
                                            <>
                                              <Grid item xs={2}>
                                                <Box sx={{ m: 1 }}>
                                                  <Field
                                                    name={`payment.${index}.mpi_type`}
                                                    validate={(value) => {
                                                      if (value?.length < 1) {
                                                        return "This field is required";
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        sx={{ pt: 0.5 }}
                                                        required
                                                        variant="standard"
                                                        name={`payment.${index}.mpi_type`}
                                                        select
                                                        label="MPI Type"
                                                        size="small"
                                                        fullWidth
                                                        value={values.payment[index].mpi_type}
                                                        onChange={handleChange}
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]?.mpi_type &&
                                                          errors.payment &&
                                                          errors?.payment?.[index]?.mpi_type
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]?.mpi_type &&
                                                          errors.payment &&
                                                          errors?.payment?.[index]?.mpi_type
                                                        }
                                                      >
                                                        {MPI_TYPE_LIST.map((item) => (
                                                          <MenuItem key={item.id} value={item.id}>
                                                            {item.name}
                                                          </MenuItem>
                                                        )) || UnavailableOptionItem}
                                                      </TextField>
                                                    )}
                                                  />
                                                </Box>
                                              </Grid>

                                              {+values.payment[index].mpi_type !== 0 && (
                                                <Grid item xs={4}>
                                                  <Box sx={{ m: 1 }}>
                                                    <Field
                                                      name={`payment.${index}.mpi_id`}
                                                      validate={(value) => {
                                                        if (value?.length < 1) {
                                                          return "This field is required";
                                                        }
                                                      }}
                                                      render={({ field }) => (
                                                        <TextField
                                                          sx={{ pt: 0.5 }}
                                                          required
                                                          variant="standard"
                                                          name={`payment.${index}.mpi_id`}
                                                          select
                                                          label="MPI (Acquirer Bin - Acquirer Merchant ID)"
                                                          size="small"
                                                          fullWidth
                                                          value={values.payment[index].mpi_id}
                                                          onChange={handleChange}
                                                          error={Boolean(
                                                            touched.payment &&
                                                            touched?.payment[index]?.mpi_id &&
                                                            errors.payment &&
                                                            errors?.payment?.[index]?.mpi_id
                                                          )}
                                                          helperText={
                                                            touched.payment &&
                                                            touched?.payment[index]?.mpi_id &&
                                                            errors.payment &&
                                                            errors?.payment?.[index]?.mpi_id
                                                          }
                                                        >
                                                          {mpiList?.map((item) => (
                                                            <MenuItem key={item.id} value={item.id}>
                                                              {item.acquirer_bin} - {item.acquirer_merchant_id}
                                                            </MenuItem>
                                                          )) || UnavailableOptionItem}
                                                        </TextField>
                                                      )}
                                                    />
                                                  </Box>
                                                </Grid>
                                              )}
                                            </>
                                          )}
                                      </Grid>

                                      <FiuuFixedFeeFields
                                        index={index}
                                        values={values}
                                        handleChange={handleChange}
                                        touched={touched}
                                        errors={errors}
                                        selectedPaymentHost={selectedPaymentHosts[index]}
                                      />

                                      {selectedPaymentHosts[index] &&
                                        showGrabPayDynamicField(
                                          selectedPaymentHosts[index]
                                        ) &&
                                        !selectedPaymentHosts[index]?.includes(PAYMENT_HOST_LIST.GRABPAY_GW2) &&
                                        !selectedPaymentHosts[index]?.toLowerCase()?.includes(PAYMENT_HOST_LIST.GRABPAY_V1) && (
                                          <Grid
                                            container
                                            column={6}
                                            alignItems="flex-end"
                                          >
                                            {!selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.GRABPAY_SG) && (
                                              <Grid item xs={2}>
                                                <FormControlLabel
                                                  sx={{ m: 1 }}
                                                  type="checkbox"
                                                  id={`payment.${index}.postpaid`}
                                                  name={`payment.${index}.postpaid`}
                                                  checked={
                                                    values.payment[index].postpaid
                                                  }
                                                  onChange={() =>
                                                    setFieldValue(
                                                      `payment.${index}.postpaid`,
                                                      !values.payment[index].postpaid
                                                    )
                                                  }
                                                  control={<Checkbox />}
                                                  label="Postpaid"
                                                />
                                              </Grid>
                                            )}
                                            <Grid item xs={2}>
                                              <FormControlLabel
                                                sx={{ m: 1 }}
                                                type="checkbox"
                                                id={`payment.${index}.installment_4`}
                                                name={`payment.${index}.installment_4`}
                                                checked={
                                                  values.payment[index].installment_4
                                                }
                                                onChange={() =>
                                                  setFieldValue(
                                                    `payment.${index}.installment_4`,
                                                    !values.payment[index]
                                                      .installment_4
                                                  )
                                                }
                                                control={<Checkbox />}
                                                label="Installment"
                                              />
                                            </Grid>
                                            {selectedPaymentHosts[index] &&
                                              selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.GRABPAY_SG) &&
                                              values.payment[index].installment_4 && (
                                                <>
                                                  <Grid item xs={2}>
                                                    <Field
                                                      name={`payment.${index}.base_rate_installment`}
                                                      validate={(value) => {
                                                        if (values.payment[index].installment_4) {
                                                          if (value?.length === 0) {
                                                            return "This field is required";
                                                          }
                                                        }
                                                      }}
                                                      render={({ field }) => (
                                                        <TextField
                                                          required
                                                          sx={{ m: 1 }}
                                                          InputLabelProps={{
                                                            shrink: true,
                                                          }}
                                                          InputProps={{
                                                            startAdornment: (
                                                              <InputAdornment position="start">
                                                                %
                                                              </InputAdornment>
                                                            ),
                                                          }}
                                                          label="Base Rate (Installment)"
                                                          id={`payment.${index}.base_rate_installment`}
                                                          name={`payment.${index}.base_rate_installment`}
                                                          value={values.payment[index].base_rate_installment}
                                                          onChange={(e) => {
                                                            handleChange(e);
                                                          }}
                                                          type="number"
                                                          error={Boolean(
                                                            touched.payment &&
                                                            touched?.payment[index]?.base_rate_installment &&
                                                            errors.payment &&
                                                            errors?.payment[index]?.base_rate_installment
                                                          )}
                                                          helperText={
                                                            touched.payment &&
                                                            touched?.payment[index]?.base_rate_installment &&
                                                            errors.payment &&
                                                            errors?.payment[index]?.base_rate_installment
                                                          }
                                                          variant="standard"
                                                        />
                                                      )}
                                                    />
                                                  </Grid>
                                                  <Grid item xs={2}>
                                                    <Field
                                                      name={`payment.${index}.markup_rate_installment`}
                                                      validate={(value) => {
                                                        if (values.payment[index].installment_4) {
                                                          if (value?.length === 0) {
                                                            return "This field is required";
                                                          }
                                                        }
                                                      }}
                                                      render={({ field }) => (
                                                        <TextField
                                                          required
                                                          sx={{ m: 1 }}
                                                          InputLabelProps={{
                                                            shrink: true,
                                                          }}
                                                          InputProps={{
                                                            startAdornment: (
                                                              <InputAdornment position="start">
                                                                %
                                                              </InputAdornment>
                                                            ),
                                                          }}
                                                          label="Markup Rate (Installment)"
                                                          id={`payment.${index}.markup_rate_installment`}
                                                          name={`payment.${index}.markup_rate_installment`}
                                                          value={values.payment[index].markup_rate_installment}
                                                          onChange={(e) => {
                                                            handleChange(e);
                                                          }}
                                                          error={Boolean(
                                                            touched.payment &&
                                                            touched?.payment[index]
                                                              ?.markup_rate_installment &&
                                                            errors.payment &&
                                                            errors?.payment[index]?.markup_rate_installment
                                                          )}
                                                          helperText={
                                                            touched.payment &&
                                                            touched?.payment[index]?.markup_rate_installment &&
                                                            errors.payment &&
                                                            errors?.payment[index]?.markup_rate_installment
                                                          }
                                                          variant="standard"
                                                          type="number"
                                                        />
                                                      )}
                                                    />
                                                  </Grid>
                                                </>
                                              )
                                            }
                                          </Grid>
                                        )}

                                      {selectedPaymentHosts[index] &&
                                        showWorldPayDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <Box>
                                            <Grid
                                              container
                                              column={6}
                                              alignItems="flex-end"
                                            >
                                              <Grid item xs={3}>
                                                <FormControlLabel
                                                  sx={{ m: 1 }}
                                                  type="checkbox"
                                                  id={`payment.${index}.enable_vis`}
                                                  name={`payment.${index}.enable_vis`}
                                                  checked={
                                                    values.payment[index].enable_vis
                                                  }
                                                  onChange={() =>
                                                    setFieldValue(
                                                      `payment.${index}.enable_vis`,
                                                      !values.payment[index]
                                                        .enable_vis
                                                    )
                                                  }
                                                  control={<Checkbox />}
                                                  label="Enable VIS"
                                                />
                                              </Grid>
                                              <Grid item xs={4}>
                                                <FormControlLabel
                                                  sx={{ m: 1 }}
                                                  type="checkbox"
                                                  id={`payment.${index}.default_bin_routing`}
                                                  name={`payment.${index}.default_bin_routing`}
                                                  checked={
                                                    values.payment[index]
                                                      .default_bin_routing
                                                  }
                                                  onChange={() =>
                                                    setFieldValue(
                                                      `payment.${index}.default_bin_routing`,
                                                      !values.payment[index]
                                                        .default_bin_routing
                                                    )
                                                  }
                                                  control={<Checkbox />}
                                                  label="Default Bin Routing"
                                                />
                                              </Grid>
                                            </Grid>
                                          </Box>
                                        )}

                                      {/* Begin Nomu */}
                                      {selectedPaymentHosts[index] &&
                                        showNomuPayDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <Grid container column={6} alignItems="center">
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.processing_account_id`}
                                                id={`payment.${index}.processing_account_id`}
                                                validate={(value) => {
                                                  if (value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.processing_account_id`}
                                                    name={`payment.${index}.processing_account_id`}
                                                    label="Processing Account Id"
                                                    value={
                                                      values.payment[index].processing_account_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.processing_account_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.processing_account_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.processing_account_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.processing_account_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>

                                            <Grid item xs={4}>
                                              <FormControlLabel
                                                sx={{ m: 1 }}
                                                type="checkbox"
                                                id={`payment.${index}.default_bin_routing`}
                                                name={`payment.${index}.default_bin_routing`}
                                                checked={
                                                  values.payment[index]
                                                    .default_bin_routing
                                                }
                                                onChange={() =>
                                                  setFieldValue(
                                                    `payment.${index}.default_bin_routing`,
                                                    !values.payment[index]
                                                      .default_bin_routing
                                                  )
                                                }
                                                control={<Checkbox />}
                                                label="Default Bin Routing"
                                              />
                                            </Grid>

                                            {!values.payment[index]
                                              .default_bin_routing && (
                                                <>
                                                  <Grid item xs={2}>
                                                    <Field
                                                      name={`payment.${index}.min_card_range`}
                                                      id={`payment.${index}.min_card_range`}
                                                      validate={(value) => {
                                                        if (value.length < 1) {
                                                          return "This field is required";
                                                        }
                                                      }}
                                                      render={({ field }) => (
                                                        <TextField
                                                          required
                                                          sx={{ m: 1 }}
                                                          InputLabelProps={{
                                                            shrink: true,
                                                          }}
                                                          // InputProps={{
                                                          //   startAdornment: (
                                                          //     <InputAdornment position="start">
                                                          //       $
                                                          //     </InputAdornment>
                                                          //   ),
                                                          // }}
                                                          label="Min Card Range"
                                                          id={`payment.${index}.min_card_range`}
                                                          name={`payment.${index}.min_card_range`}
                                                          value={
                                                            values.payment[index]
                                                              .min_card_range
                                                          }
                                                          onChange={(e) => {
                                                            handleChange(e);
                                                          }}
                                                          error={Boolean(
                                                            touched.payment &&
                                                            touched?.payment[index]
                                                              ?.min_card_range &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.min_card_range
                                                          )}
                                                          helperText={
                                                            touched.payment &&
                                                            touched.payment[index]
                                                              ?.min_card_range &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.min_card_range
                                                          }
                                                          variant="standard"
                                                        />
                                                      )}
                                                    />
                                                  </Grid>
                                                  <Grid item xs={2}>
                                                    <Field
                                                      name={`payment.${index}.max_card_range`}
                                                      id={`payment.${index}.max_card_range`}
                                                      validate={(value) => {
                                                        if (value.length < 1) {
                                                          return "This field is required";
                                                        }
                                                      }}
                                                      render={({ field }) => (
                                                        <TextField
                                                          required
                                                          sx={{ m: 1 }}
                                                          InputLabelProps={{
                                                            shrink: true,
                                                          }}
                                                          // InputProps={{
                                                          //   startAdornment: (
                                                          //     <InputAdornment position="start">
                                                          //       $
                                                          //     </InputAdornment>
                                                          //   ),
                                                          // }}
                                                          label="Max Card Range"
                                                          id={`payment.${index}.max_card_range`}
                                                          name={`payment.${index}.max_card_range`}
                                                          value={
                                                            values.payment[index]
                                                              .max_card_range
                                                          }
                                                          onChange={(e) => {
                                                            handleChange(e);
                                                          }}
                                                          error={Boolean(
                                                            touched.payment &&
                                                            touched?.payment[index]
                                                              ?.max_card_range &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.max_card_range
                                                          )}
                                                          helperText={
                                                            touched.payment &&
                                                            touched?.payment[index]
                                                              ?.max_card_range &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.max_card_range
                                                          }
                                                          variant="standard"
                                                        />
                                                      )}
                                                    />
                                                  </Grid>
                                                </>
                                              )}

                                          </Grid>
                                        )
                                        //end Nomu
                                      }

                                      {/* Begin Razer */}
                                      {selectedPaymentHosts[index] &&
                                        showRazerDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <Grid container column={6} alignItems="center">
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.secret_key`}
                                                id={`payment.${index}.secret_key`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.secret_key`}
                                                    name={`payment.${index}.secret_key`}
                                                    label="Secret Key"
                                                    value={
                                                      values?.payment[index]?.secret_key
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.secret_key &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.secret_key
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.secret_key &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.secret_key
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>

                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.verification_key`}
                                                id={`payment.${index}.verification_key`}
                                                validate={(value) => {
                                                  if (value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.verification_key`}
                                                    name={`payment.${index}.verification_key`}
                                                    label="Verification Key"
                                                    value={
                                                      values.payment[index].verification_key
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.verification_key &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.verification_key
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.verification_key &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.verification_key
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>

                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.merchant_id`}
                                                id={`payment.${index}.merchant_id`}
                                                validate={(value) => {
                                                  if (value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.merchant_id`}
                                                    name={`payment.${index}.merchant_id`}
                                                    label="Merchant id"
                                                    value={
                                                      values.payment[index].merchant_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.merchant_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.merchant_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.merchant_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.merchant_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>

                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.channel`}
                                                id={`payment.${index}.channel`}
                                                validate={(value) => {
                                                  if (value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.channel`}
                                                    name={`payment.${index}.channel`}
                                                    label="Channel"
                                                    value={
                                                      values.payment[index].channel
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.channel &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.channel
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.channel &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.channel
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                          </Grid>
                                        )
                                        //end Razer
                                      }

                                      {/* Begin Fiuu */}
                                      {selectedPaymentHosts[index] &&
                                        showFiuuDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <Grid container column={6} alignItems="center">
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.secret_key`}
                                                id={`payment.${index}.secret_key`}
                                                validate={(value) => {
                                                  if (value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.secret_key`}
                                                    name={`payment.${index}.secret_key`}
                                                    label="Secret Key"
                                                    value={
                                                      values.payment[index].secret_key
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.secret_key &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.secret_key
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.secret_key &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.secret_key
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.merchant_id`}
                                                id={`payment.${index}.merchant_id`}
                                                validate={(value) => {
                                                  if (value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.merchant_id`}
                                                    name={`payment.${index}.merchant_id`}
                                                    label="Merchant id"
                                                    value={
                                                      values.payment[index].merchant_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.merchant_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.merchant_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.merchant_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.merchant_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.terminal_id`}
                                                id={`payment.${index}.terminal_id`}
                                                render={({ field }) => (
                                                  <TextField
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.terminal_id`}
                                                    name={`payment.${index}.terminal_id`}
                                                    label="Terminal ID"
                                                    value={
                                                      values.payment[index].terminal_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.terminal_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.terminal_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.terminal_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.terminal_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                          </Grid>
                                        )
                                        //end Fiuu
                                      }

                                      {/* Begin Allinpay */}
                                      <AllinpayFields
                                        index={index}
                                        values={values}
                                        handleChange={handleChange}
                                        touched={touched}
                                        errors={errors}
                                        selectedPaymentHost={selectedPaymentHosts[index]}
                                        section="identifiers"
                                      />
                                      {/* End Allinpay */}
                                      {/* Begin Nets */}
                                      {selectedPaymentHosts[index] &&
                                        showNetsDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <Grid container column={6} alignItems="center">
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.secret_id`}
                                                id={`payment.${index}.secret_id`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.secret_id`}
                                                    name={`payment.${index}.secret_id`}
                                                    label="SecretID"
                                                    value={
                                                      values.payment[index].secret_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.secret_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.secret_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.secret_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.secret_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.key_id`}
                                                id={`payment.${index}.key_id`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.key_id`}
                                                    name={`payment.${index}.key_id`}
                                                    label="KeyID"
                                                    value={
                                                      values.payment[index].key_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.key_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.key_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.key_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.key_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.mid`}
                                                id={`payment.${index}.mid`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.mid`}
                                                    name={`payment.${index}.mid`}
                                                    label="MID"
                                                    value={
                                                      values.payment[index].mid
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.mid &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.mid
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.mid &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.mid
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.tid`}
                                                id={`payment.${index}.tid`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.tid`}
                                                    name={`payment.${index}.tid`}
                                                    label="TID"
                                                    value={
                                                      values.payment[index].tid
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.tid &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.tid
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.tid &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.tid
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.institution_code`}
                                                id={`payment.${index}.institution_code`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.institution_code`}
                                                    name={`payment.${index}.institution_code`}
                                                    label="InstitutionCode"
                                                    value={
                                                      values.payment[index].institution_code
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.institution_code &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.institution_code
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.institution_code &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.institution_code
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.condition_code`}
                                                id={`payment.${index}.condition_code`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.condition_code`}
                                                    name={`payment.${index}.condition_code`}
                                                    label="Condition Code"
                                                    value={
                                                      values.payment[index].condition_code
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.condition_code &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.condition_code
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.condition_code &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.condition_code
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                          </Grid>
                                        )
                                        //end Nets
                                      }

                                      {/* Begin Shopback */}
                                      {selectedPaymentHosts[index] &&
                                        showShopbackDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <Grid container column={6} alignItems="center">
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.access_key_id`}
                                                id={`payment.${index}.access_key_id`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.access_key_id`}
                                                    name={`payment.${index}.access_key_id`}
                                                    label="Access Key ID"
                                                    value={
                                                      values.payment[index].access_key_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.access_key_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.access_key_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.access_key_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.access_key_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.access_key_secret`}
                                                id={`payment.${index}.access_key_secret`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.access_key_secret`}
                                                    name={`payment.${index}.access_key_secret`}
                                                    label="Access Key Secret"
                                                    value={
                                                      values.payment[index].access_key_secret
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.access_key_secret &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.access_key_secret
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.access_key_secret &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.access_key_secret
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.pos_id`}
                                                id={`payment.${index}.pos_id`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.pos_id`}
                                                    name={`payment.${index}.pos_id`}
                                                    label="POS ID"
                                                    value={
                                                      values.payment[index].pos_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.pos_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.pos_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.pos_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.pos_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                          </Grid>
                                        )
                                        //end Shopback
                                      }

                                      {/* Begin host_fiuu */}
                                      {selectedPaymentHosts[index] &&
                                        showHostFiuuDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <Grid container column={6} alignItems="center">
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.host_fiuu_mid`}
                                                id={`payment.${index}.host_fiuu_mid`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.host_fiuu_mid`}
                                                    name={`payment.${index}.host_fiuu_mid`}
                                                    label="MID"
                                                    value={
                                                      values.payment[index].host_fiuu_mid
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.host_fiuu_mid &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.host_fiuu_mid
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.host_fiuu_mid &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.host_fiuu_mid
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.host_fiuu_verify_key`}
                                                id={`payment.${index}.host_fiuu_verify_key`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.host_fiuu_verify_key`}
                                                    name={`payment.${index}.host_fiuu_verify_key`}
                                                    label="VerifyKey"
                                                    value={
                                                      values.payment[index].host_fiuu_verify_key
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.host_fiuu_verify_key &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.host_fiuu_verify_key
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.host_fiuu_verify_key &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.host_fiuu_verify_key
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.host_fiuu_secret_key`}
                                                id={`payment.${index}.host_fiuu_secret_key`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.host_fiuu_secret_key`}
                                                    name={`payment.${index}.host_fiuu_secret_key`}
                                                    label="Secret Key"
                                                    value={
                                                      values.payment[index].host_fiuu_secret_key
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.host_fiuu_secret_key &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.host_fiuu_secret_key
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.host_fiuu_secret_key &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.host_fiuu_secret_key
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            {/* <Grid item xs={2}>
                                        <Field
                                          name={`payment.${index}.host_fiuu_email`}
                                          id={`payment.${index}.host_fiuu_email`}
                                          validate={(value) => {
                                            if (!value ||value.length < 1) {
                                              return "This field is required";
                                            }
                                          }}
                                          render={({ field }) => (
                                            <TextField
                                              required
                                              sx={{ m: 1 }}
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              id={`payment.${index}.host_fiuu_email`}
                                              name={`payment.${index}.host_fiuu_email`}
                                              label="Email"
                                              value={
                                                values.payment[index].host_fiuu_email
                                              }
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                              error={Boolean(
                                                touched.payment &&
                                                touched?.payment[index]
                                                  ?.host_fiuu_email &&
                                                errors.payment &&
                                                errors?.payment[index]?.host_fiuu_email
                                              )}
                                              helperText={
                                                touched.payment &&
                                                touched?.payment[index]
                                                  ?.host_fiuu_email &&
                                                errors.payment &&
                                                errors?.payment[index]?.host_fiuu_email
                                              }
                                              variant="standard"
                                            />
                                          )}
                                        />
                                      </Grid>
                                      <Grid item xs={2}>
                                        <Field
                                          name={`payment.${index}.host_fiuu_password`}
                                          id={`payment.${index}.host_fiuu_password`}
                                          validate={(value) => {
                                            if (!value ||value.length < 1) {
                                              return "This field is required";
                                            }
                                          }}
                                          render={({ field }) => (
                                            <TextField
                                              required
                                              sx={{ m: 1 }}
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              id={`payment.${index}.host_fiuu_password`}
                                              name={`payment.${index}.host_fiuu_password`}
                                              label="Password"
                                              value={
                                                values.payment[index].host_fiuu_password
                                              }
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                              error={Boolean(
                                                touched.payment &&
                                                touched?.payment[index]
                                                  ?.host_fiuu_password &&
                                                errors.payment &&
                                                errors?.payment[index]?.host_fiuu_password
                                              )}
                                              helperText={
                                                touched.payment &&
                                                touched?.payment[index]
                                                  ?.host_fiuu_password &&
                                                errors.payment &&
                                                errors?.payment[index]?.host_fiuu_password
                                              }
                                              variant="standard"
                                            />
                                          )}
                                        />
                                      </Grid> */}
                                          </Grid>
                                        )
                                        //end Nets
                                      }

                                      {/* Begin Cybersource */}
                                      {selectedPaymentHosts[index] &&
                                        showCybersourceDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <>
                                            <Grid container column={6} alignItems="center">
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.cybs_merchant_id`}
                                                  id={`payment.${index}.cybs_merchant_id`}
                                                  validate={(value) => {
                                                    if (!value || value.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      id={`payment.${index}.cybs_merchant_id`}
                                                      name={`payment.${index}.cybs_merchant_id`}
                                                      label="Merchant ID"
                                                      value={
                                                        values.payment[index].cybs_merchant_id
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.cybs_merchant_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.cybs_merchant_id
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.cybs_merchant_id &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.cybs_merchant_id
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.cybs_merchant_keyid`}
                                                  id={`payment.${index}.cybs_merchant_keyid`}
                                                  validate={(value) => {
                                                    if (!value || value.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      id={`payment.${index}.cybs_merchant_keyid`}
                                                      name={`payment.${index}.cybs_merchant_keyid`}
                                                      label="Key ID"
                                                      value={
                                                        values.payment[index].cybs_merchant_keyid
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.cybs_merchant_keyid &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.cybs_merchant_keyid
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.cybs_merchant_keyid &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.cybs_merchant_keyid
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.cybs_merchant_secretkey`}
                                                  id={`payment.${index}.cybs_merchant_secretkey`}
                                                  validate={(value) => {
                                                    if (!value || value.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      id={`payment.${index}.cybs_merchant_secretkey`}
                                                      name={`payment.${index}.cybs_merchant_secretkey`}
                                                      label="Secret Key"
                                                      value={
                                                        values.payment[index].cybs_merchant_secretkey
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.cybs_merchant_secretkey &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.cybs_merchant_secretkey
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.cybs_merchant_secretkey &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.cybs_merchant_secretkey
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.cybs_mpi_type`}
                                                  id={`payment.${index}.cybs_mpi_type`}
                                                  validate={(value) => {
                                                    if (value === undefined || value === null || value === "") {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      select
                                                      label="MPI Type"
                                                      id={`payment.${index}.cybs_mpi_type`}
                                                      name={`payment.${index}.cybs_mpi_type`}
                                                      value={
                                                        values.payment[index].cybs_mpi_type !== undefined
                                                          ? values.payment[index].cybs_mpi_type
                                                          : 0
                                                      }
                                                      onChange={handleChange}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.cybs_mpi_type &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.cybs_mpi_type
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.cybs_mpi_type &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.cybs_mpi_type
                                                      }
                                                      variant="standard"
                                                    >
                                                      {MPI_TYPE_LIST.slice(0, 2).map((item) => (
                                                        <MenuItem key={item.id} value={item.id}>
                                                          {item.name}
                                                        </MenuItem>
                                                      )) || UnavailableOptionItem}
                                                    </TextField>
                                                  )}
                                                />
                                              </Grid>
                                            </Grid>

                                            {/* IPP Enabled Checkbox */}
                                            <Grid container column={6} alignItems="center" sx={{ mt: 2 }}>
                                              <Grid item xs={12}>
                                                <FormControlLabel
                                                  control={
                                                    <Checkbox
                                                      checked={values.payment[index].ipp_enabled || false}
                                                      onChange={(e) => {
                                                        setFieldValue(`payment.${index}.ipp_enabled`, e.target.checked);
                                                        if (!e.target.checked) {
                                                          setFieldValue(`payment.${index}.ipp_plans`, []);
                                                        } else {
                                                          const currentPlans = values.payment[index].ipp_plans || [];
                                                          if (currentPlans.length === 0) {
                                                            setFieldValue(`payment.${index}.ipp_plans`, []);
                                                          }
                                                        }
                                                      }}
                                                    />
                                                  }
                                                  label="Installment payment plan"
                                                />
                                              </Grid>
                                            </Grid>

                                            {/* IPP Plans - Dynamic FieldArray */}
                                            {values.payment[index].ipp_enabled && (
                                              <FieldArray name={`payment.${index}.ipp_plans`}>
                                                {({ push, remove }) => (
                                                  <Grid container spacing={2} sx={{ mt: 1, mb: 2 }}>
                                                    {values.payment[index].ipp_plans?.map((plan, planIndex) => (
                                                      <Grid item xs={12} key={planIndex}>
                                                        <Card sx={{ p: 2, border: '1px solid #e0e0e0' }}>
                                                          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                                                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                                              Plan {planIndex + 1}
                                                            </Typography>
                                                            <Button
                                                              variant="outlined"
                                                              color="error"
                                                              size="small"
                                                              startIcon={<Close />}
                                                              onClick={() => remove(planIndex)}
                                                              disabled={isSubmitting}
                                                            >
                                                              Remove
                                                            </Button>
                                                          </Stack>
                                                          <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                              <Field
                                                                name={`payment.${index}.ipp_plans.${planIndex}.bank`}
                                                                validate={(value) => {
                                                                  if (!value || value.length < 1) {
                                                                    return "This field is required";
                                                                  }
                                                                }}
                                                                render={({ field }) => (
                                                                  <TextField
                                                                    {...field}
                                                                    required
                                                                    fullWidth
                                                                    size="small"
                                                                    label="Bank"
                                                                    error={Boolean(
                                                                      touched.payment?.[index]?.ipp_plans?.[planIndex]?.bank &&
                                                                      errors.payment?.[index]?.ipp_plans?.[planIndex]?.bank
                                                                    )}
                                                                    helperText={
                                                                      touched.payment?.[index]?.ipp_plans?.[planIndex]?.bank &&
                                                                      errors.payment?.[index]?.ipp_plans?.[planIndex]?.bank
                                                                    }
                                                                  />
                                                                )}
                                                              />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                              <Field
                                                                name={`payment.${index}.ipp_plans.${planIndex}.months`}
                                                                validate={(value) => {
                                                                  if (!value || value === null || value === undefined || value === "") {
                                                                    return "This field is required";
                                                                  }
                                                                  if (isNaN(value) || Number(value) <= 0) {
                                                                    return "Must be a positive number";
                                                                  }
                                                                }}
                                                                render={({ field }) => (
                                                                  <TextField
                                                                    {...field}
                                                                    required
                                                                    fullWidth
                                                                    size="small"
                                                                    type="number"
                                                                    label="Months"
                                                                    error={Boolean(
                                                                      touched.payment?.[index]?.ipp_plans?.[planIndex]?.months &&
                                                                      errors.payment?.[index]?.ipp_plans?.[planIndex]?.months
                                                                    )}
                                                                    helperText={
                                                                      touched.payment?.[index]?.ipp_plans?.[planIndex]?.months &&
                                                                      errors.payment?.[index]?.ipp_plans?.[planIndex]?.months
                                                                    }
                                                                  />
                                                                )}
                                                              />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                              <Field
                                                                name={`payment.${index}.ipp_plans.${planIndex}.ipp_merchant_id`}
                                                                validate={(value) => {
                                                                  if (!value || value.length < 1) {
                                                                    return "This field is required";
                                                                  }
                                                                }}
                                                                render={({ field }) => (
                                                                  <TextField
                                                                    {...field}
                                                                    required
                                                                    fullWidth
                                                                    size="small"
                                                                    label="Merchant ID"
                                                                    error={Boolean(
                                                                      touched.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_id &&
                                                                      errors.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_id
                                                                    )}
                                                                    helperText={
                                                                      touched.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_id &&
                                                                      errors.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_id
                                                                    }
                                                                  />
                                                                )}
                                                              />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                              <Field
                                                                name={`payment.${index}.ipp_plans.${planIndex}.ipp_merchant_keyid`}
                                                                validate={(value) => {
                                                                  if (!value || value.length < 1) {
                                                                    return "This field is required";
                                                                  }
                                                                }}
                                                                render={({ field }) => (
                                                                  <TextField
                                                                    {...field}
                                                                    required
                                                                    fullWidth
                                                                    size="small"
                                                                    label="Merchant Key ID"
                                                                    error={Boolean(
                                                                      touched.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_keyid &&
                                                                      errors.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_keyid
                                                                    )}
                                                                    helperText={
                                                                      touched.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_keyid &&
                                                                      errors.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_keyid
                                                                    }
                                                                  />
                                                                )}
                                                              />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                              <Field
                                                                name={`payment.${index}.ipp_plans.${planIndex}.ipp_merchant_secretkey`}
                                                                validate={(value) => {
                                                                  if (!value || value.length < 1) {
                                                                    return "This field is required";
                                                                  }
                                                                }}
                                                                render={({ field }) => (
                                                                  <TextField
                                                                    {...field}
                                                                    required
                                                                    fullWidth
                                                                    size="small"
                                                                    type="password"
                                                                    label="Merchant Secret Key"
                                                                    error={Boolean(
                                                                      touched.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_secretkey &&
                                                                      errors.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_secretkey
                                                                    )}
                                                                    helperText={
                                                                      touched.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_secretkey &&
                                                                      errors.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_secretkey
                                                                    }
                                                                  />
                                                                )}
                                                              />
                                                            </Grid>
                                                          </Grid>
                                                        </Card>
                                                      </Grid>
                                                    ))}
                                                    <Grid item xs={12}>
                                                      <Button
                                                        variant="outlined"
                                                        startIcon={<AddCircleOutlined />}
                                                        onClick={() => push({ bank: '', months: '', ipp_merchant_id: '', ipp_merchant_keyid: '', ipp_merchant_secretkey: '' })}
                                                        disabled={isSubmitting}
                                                        sx={{ mt: 1 }}
                                                      >
                                                        Add Plan
                                                      </Button>
                                                    </Grid>
                                                  </Grid>
                                                )}
                                              </FieldArray>
                                            )}
                                          </>
                                        )
                                        //end Cybersource
                                      }

                                      {/* Begin Dci */}
                                      {selectedPaymentHosts?.[index]?.toLowerCase().startsWith(PAYMENT_HOST_LIST.DCI) && (
                                        <Grid container column={6} alignItems="center">
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.acquiring_institution_id`}
                                              id={`payment.${index}.acquiring_institution_id`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.acquiring_institution_id`}
                                                  name={`payment.${index}.acquiring_institution_id`}
                                                  label="Acquiring Institution Id"
                                                  value={
                                                    values.payment[index].acquiring_institution_id
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.acquiring_institution_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.acquiring_institution_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.acquiring_institution_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.acquiring_institution_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.forwarding_institution_id`}
                                              id={`payment.${index}.forwarding_institution_id`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.forwarding_institution_id`}
                                                  name={`payment.${index}.forwarding_institution_id`}
                                                  label="Forwarding Institution Id"
                                                  value={
                                                    values.payment[index].forwarding_institution_id
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.forwarding_institution_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.forwarding_institution_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.forwarding_institution_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.forwarding_institution_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.acceptor_id`}
                                              id={`payment.${index}.acceptor_id`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.acceptor_id`}
                                                  name={`payment.${index}.acceptor_id`}
                                                  label="Acceptor Id"
                                                  value={
                                                    values.payment[index].acceptor_id
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.acceptor_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.acceptor_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.acceptor_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.acceptor_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.processing_code`}
                                              id={`payment.${index}.processing_code`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.processing_code`}
                                                  name={`payment.${index}.processing_code`}
                                                  label="Processing Code"
                                                  value={
                                                    values.payment[index].processing_code
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.processing_code &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.processing_code
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.processing_code &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.processing_code
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.dci_descriptor`}
                                              id={`payment.${index}.dci_descriptor`}
                                              validate={(value) => {
                                                if (value?.length > 36) {
                                                  return "This field cannot exceed 36 characters.";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.dci_descriptor`}
                                                  name={`payment.${index}.dci_descriptor`}
                                                  label="DCI Descriptor"
                                                  value={
                                                    values.payment[index].dci_descriptor
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.dci_descriptor &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.dci_descriptor
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.dci_descriptor &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.dci_descriptor
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                        </Grid>
                                      )
                                        //end Dci
                                      }

                                      {/* Rate Fields (paydee) */}
                                      {selectedPaymentHosts[index] && showPaydeeDynamicField(selectedPaymentHosts[index]) && (
                                        <Grid item xs={12}>
                                          <Grid container spacing={2} alignItems="flex-end">

                                            {/* Rate fields */}
                                            <Grid item xs={12}>
                                              <Box sx={{ mt: 1, ml: 1 }}>
                                                <Grid container spacing={2}>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Base Rate (Local Debit)" name={`payment.${index}.local_debit_base_rate`}
                                                      value={values.payment[index].local_debit_base_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Markup Rate (Local Debit)" name={`payment.${index}.local_debit_markup_rate`}
                                                      value={values.payment[index].local_debit_markup_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                </Grid>

                                                <Grid container spacing={2}>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Base Rate (Local Credit)" name={`payment.${index}.local_credit_base_rate`}
                                                      value={values.payment[index].local_credit_base_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Markup Rate (Local Credit)" name={`payment.${index}.local_credit_markup_rate`}
                                                      value={values.payment[index].local_credit_markup_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                </Grid>

                                                <Grid container spacing={2}>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Base Rate (Foreign Card)" name={`payment.${index}.foreign_base_rate`}
                                                      value={values.payment[index].foreign_base_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Markup Rate (Foreign Card)" name={`payment.${index}.foreign_markup_rate`}
                                                      value={values.payment[index].foreign_markup_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                </Grid>
                                              </Box>
                                            </Grid>

                                            <Grid item xs={3}>
                                              <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                InputProps={{ startAdornment: <InputAdornment position="start">¢</InputAdornment> }}
                                                type="number" label="Minimum MDR"
                                                id={`payment.${index}.whichever_higher_mdr_cents`} name={`payment.${index}.whichever_higher_mdr_cents`}
                                                value={values.payment[index].whichever_higher_mdr_cents} onChange={handleChange} variant="standard" />
                                            </Grid>

                                            <Grid item xs={3}>
                                              <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                InputProps={{ startAdornment: <InputAdornment position="start">¢</InputAdornment> }}
                                                type="number" label="Micro Transaction Amount"
                                                id={`payment.${index}.micro_transaction_amount`} name={`payment.${index}.micro_transaction_amount`}
                                                value={values.payment[index].micro_transaction_amount} onChange={handleChange} variant="standard" />
                                            </Grid>

                                            <Grid item xs={3}>
                                              <TextField
                                                fullWidth
                                                sx={{ m: 1, "& .MuiInputLabel-root": { whiteSpace: "pre-line", lineHeight: "1.1", top: "-4px" } }}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ startAdornment: <InputAdornment position="start">¢</InputAdornment> }}
                                                type="number"
                                                label={`Micro Transaction MDR`}
                                                id={`payment.${index}.mdr_less_than_micro_transaction_amount_cents`}
                                                name={`payment.${index}.mdr_less_than_micro_transaction_amount_cents`}
                                                value={values.payment[index].mdr_less_than_micro_transaction_amount_cents}
                                                onChange={handleChange}
                                                variant="standard"
                                              />
                                            </Grid>

                                          </Grid>
                                        </Grid>
                                      )}

                                      {/* Rate Fields (bsn) */}
                                      {selectedPaymentHosts[index] && showBSNDynamicField(selectedPaymentHosts[index]) && (
                                        <Grid item xs={12}>
                                          <Grid container spacing={2} alignItems="flex-end">

                                            {/* Rate fields */}
                                            <Grid item xs={12}>
                                              <Box sx={{ mt: 1, ml: 1 }}>
                                                <Grid container spacing={2}>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Base Rate (Local Debit)" name={`payment.${index}.local_debit_base_rate`}
                                                      value={values.payment[index].local_debit_base_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Markup Rate (Local Debit)" name={`payment.${index}.local_debit_markup_rate`}
                                                      value={values.payment[index].local_debit_markup_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                </Grid>

                                                <Grid container spacing={2}>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Base Rate (Local Credit)" name={`payment.${index}.local_credit_base_rate`}
                                                      value={values.payment[index].local_credit_base_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Markup Rate (Local Credit)" name={`payment.${index}.local_credit_markup_rate`}
                                                      value={values.payment[index].local_credit_markup_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                </Grid>

                                                <Grid container spacing={2}>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Base Rate (Foreign Card)" name={`payment.${index}.foreign_base_rate`}
                                                      value={values.payment[index].foreign_base_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Markup Rate (Foreign Card)" name={`payment.${index}.foreign_markup_rate`}
                                                      value={values.payment[index].foreign_markup_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                </Grid>

                                                <Grid container spacing={2}>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Base Rate (MyDebit Card)" name={`payment.${index}.my_debit_base_rate`}
                                                      value={values.payment[index].my_debit_base_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Markup Rate (MyDebit Card)" name={`payment.${index}.my_debit_markup_rate`}
                                                      value={values.payment[index].my_debit_markup_rate} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                </Grid>
                                              </Box>
                                            </Grid>

                                            <Grid item xs={3}>
                                              <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                InputProps={{ startAdornment: <InputAdornment position="start">¢</InputAdornment> }}
                                                type="number" label="Minimum MDR"
                                                id={`payment.${index}.whichever_higher_mdr_cents`} name={`payment.${index}.whichever_higher_mdr_cents`}
                                                value={values.payment[index].whichever_higher_mdr_cents} onChange={handleChange} variant="standard" />
                                            </Grid>

                                            <Grid item xs={3}>
                                              <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                InputProps={{ startAdornment: <InputAdornment position="start">¢</InputAdornment> }}
                                                type="number" label="Micro Transaction Amount"
                                                id={`payment.${index}.micro_transaction_amount`} name={`payment.${index}.micro_transaction_amount`}
                                                value={values.payment[index].micro_transaction_amount} onChange={handleChange} variant="standard" />
                                            </Grid>

                                            <Grid item xs={3}>
                                              <TextField
                                                fullWidth
                                                sx={{ m: 1, "& .MuiInputLabel-root": { whiteSpace: "pre-line", lineHeight: "1.1", top: "-4px" } }}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ startAdornment: <InputAdornment position="start">¢</InputAdornment> }}
                                                type="number"
                                                label={`Micro Transaction MDR`}
                                                id={`payment.${index}.mdr_less_than_micro_transaction_amount_cents`}
                                                name={`payment.${index}.mdr_less_than_micro_transaction_amount_cents`}
                                                value={values.payment[index].mdr_less_than_micro_transaction_amount_cents}
                                                onChange={handleChange}
                                                variant="standard"
                                              />
                                            </Grid>

                                          </Grid>
                                        </Grid>
                                      )}

                                      {/* Begin Revpay */}
                                      {selectedPaymentHosts[index] &&
                                        showRevPayDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <Grid container column={6} alignItems="center">
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.revpay_merchant_id`}
                                                id={`payment.${index}.revpay_merchant_id`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.revpay_merchant_id`}
                                                    name={`payment.${index}.revpay_merchant_id`}
                                                    label="RevPay Merchant ID"
                                                    value={
                                                      values.payment[index].revpay_merchant_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.revpay_merchant_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.revpay_merchant_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.revpay_merchant_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.revpay_merchant_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                          </Grid>
                                        )
                                        //end revpay
                                      }

                                      {/* Rate Fields (shopeepay-my) */}
                                      {selectedPaymentHosts[index] && showShopeePayMYDynamicField(selectedPaymentHosts[index]) && (
                                        <Grid item xs={12}>
                                          <Grid container spacing={2} alignItems="flex-end">

                                            {/* Rate fields */}
                                            <Grid item xs={12}>
                                              <Box sx={{ mt: 1, ml: 1 }}>
                                                <Grid container spacing={2}>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="text" label="MY Merchant Ext ID" name={`payment.${index}.my_merchant_ext_id`}
                                                      value={values.payment[index].my_merchant_ext_id} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="text" label="MY Store Ext ID" name={`payment.${index}.my_store_ext_id`}
                                                      value={values.payment[index].my_store_ext_id} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                </Grid>

                                                <Grid container spacing={2}>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Convenience Fee Indicator" name={`payment.${index}.convenience_fee_indicator`}
                                                      value={values.payment[index].convenience_fee_indicator} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Convenience Fee Fixed" name={`payment.${index}.convenience_fee_fixed`}
                                                      value={values.payment[index].convenience_fee_fixed} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                  <Grid item xs={3}>
                                                    <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                      InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                      type="number" label="Convenience Fee Percentage" name={`payment.${index}.convenience_fee_percentage`}
                                                      value={values.payment[index].convenience_fee_percentage} onChange={handleChange} variant="standard" />
                                                  </Grid>
                                                </Grid>

                                                {/* AutoDebit */}
                                                <Grid container spacing={2}>
                                                  <Grid item xs={3}>
                                                    <FormControlLabel
                                                      sx={{ m: 1 }}
                                                      control={
                                                        <Checkbox
                                                          name={`payment.${index}.is_autodebit_enabled`}
                                                          checked={Boolean(values.payment[index].is_autodebit_enabled)}
                                                          onChange={(e) => {
                                                            setFieldValue(
                                                              `payment.${index}.is_autodebit_enabled`,
                                                              e.target.checked
                                                            );
                                                            if (!e.target.checked) {
                                                              setFieldValue(`payment.${index}.autodebit_amount`, "");
                                                            }
                                                          }}
                                                        />
                                                      }
                                                      label="Enable AutoDebit"
                                                    />
                                                  </Grid>

                                                  {values.payment[index].is_autodebit_enabled && (
                                                    <Grid item xs={3}>
                                                      <TextField
                                                        fullWidth
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{ shrink: true }}
                                                        type="number"
                                                        label="AutoDebit Amount"
                                                        name={`payment.${index}.autodebit_amount`}
                                                        value={values.payment[index].autodebit_amount}
                                                        onChange={handleChange}
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]?.autodebit_amount &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.autodebit_amount
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]?.autodebit_amount &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.autodebit_amount
                                                        }
                                                        variant="standard"
                                                      />
                                                    </Grid>
                                                  )}
                                                </Grid>

                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}

                                      {selectedPaymentHosts?.[index] === routeGw2[index]?.name && routeGw2[index]?.isRouteGw2 &&
                                        <Grid
                                          container
                                          column={12}
                                        >
                                          <>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.gw2_params.mcptid`}
                                                id={`payment.${index}.gw2_params.mcptid`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.gw2_params.mcptid`}
                                                    name={`payment.${index}.gw2_params.mcptid`}
                                                    label="MCPTID"
                                                    value={
                                                      values.payment[index]?.gw2_params?.mcptid
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.gw2_params?.mcptid &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.gw2_params?.mcptid
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.gw2_params?.mcptid &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.gw2_params?.mcptid
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>

                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.gw2_params.etype`}
                                                id={`payment.${index}.gw2_params.etype`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.gw2_params.etype`}
                                                    name={`payment.${index}.gw2_params.etype`}
                                                    label="EType"
                                                    value={
                                                      values.payment[index]?.gw2_params?.etype
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.gw2_params?.etype &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.gw2_params?.etype
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.gw2_params?.etype &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.gw2_params?.etype
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                          </>

                                          <Grid item xs={4}>
                                            <FormControlLabel
                                              sx={{ m: 1 }}
                                              type="checkbox"
                                              id={`payment.${index}.route_enabled`}
                                              name={`payment.${index}.route_enabled`}
                                              checked={
                                                values.payment[index].route_enabled
                                              }
                                              onChange={() =>
                                                setFieldValue(
                                                  `payment.${index}.route_enabled`,
                                                  !values.payment[index].route_enabled
                                                )
                                              }
                                              control={<Checkbox />}
                                              label="Enable Route GW2"
                                            />
                                          </Grid>
                                        </Grid>
                                      }

                                    </Card>
                                  );
                                })}

                              <Button
                                onClick={() =>
                                  push({
                                    ...initialRow[0],
                                  })
                                }
                                variant="contained"
                                startIcon={<AddCircleOutlined />}
                                sx={{ m: 2, ...styles.customButton }}
                              >
                                Add New Route
                              </Button>
                            </Box>
                          )}
                        </FieldArray>
                      </Grid>
                    </Grid>
                  </Form>
                </FormDialog>
              );
            }}
          </Formik>
        </Box>
      ) : (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Container>
  );
};

export default CreateNewTerminal;
